var pt = {
	"header_logout": "Sair",
	"header_return_overview": "Visão Geral",
	"header_welcome": "Bem-vindo ao dashboard de ",
	"header_account_status": "Status da conta",

	"menu_overview": "Visão Geral",
	"menu_news": "Avisos",
	"menu_search_order": "Buscar Pedido",
	"menu_update_information": "Conta",
	"menu_account_estab_comercial": "Registro do Estabelecimento na CERC",
	"menu_account_cerc": "CERC",
	"menu_account_group": "Grupo",
	"menu_account_revenue_group": "Grupo de Receita",
	"menu_account_user": "Merchant - Usuários",
	"menu_account_product": "Produtos",
	"menu_account_email": "E-mail/SMS Config",
	"menu_account_config": "Configuração",
	"menu_account_report": "Relatório diário",
	"menu_account_fee": "Taxa",
	"menu_account_custom": "Personalização",
	"menu_account_user_config": "Configurações de Usuário",
	"menu_account_user_list": "Usuários",
	"menu_account_seller": "Vendedores",
	"menu_account_shopify": "Shopify",
	"menu_pos_register": "Registro de POS",
	"menu_modelo_contrato": "Modelo de Contrato",

	"menu_super_config": "Super Config.",

	"menu_reports": "Relatórios",
	"menu_remittances": "Remessas",
	"menu_settlement_reports": "Conciliação",
	"menu_sales_reports": "Vendas",
	"menu_commission_reports": "Relatório de Comissão",
	"menu_graphics": "Gráficos",
	"menu_pixconfig": "Configuração de Pix",
	"menu_blocklist_pix_roaming": "Lista de bloqueio de Pix para turistas estrangeiros",
	"menu_feesconfig": "Configuração de Taxas",
	"menu_resources": "Recursos",
	"menu_checkout": "PB Checkout",
	"menu_offline_payment": "Link de Pagamento",
	"menu_offline_payment_create": "Criar",
	"menu_search_offline_payment": "Buscar",
	"menu_trial": "Trial",
	"menu_pagshield": "PagShield",
	"menu_ipn_history": "Histórico de IPNs",
	"menu_ipn": "IPN",
	"menu_payout": "Payout",
	"menu_webhook": "Webhook",
	"menu_full_stats": "Estatísticas",
	"menu_calendar": "Calendário",
	"menu_approval": "Homologação",
	"menu_statistics": "Estatísticas por Data do Pedido",
	"menu_statistics_payment": "Estatísticas por Data de Pagamento",
	"menu_chargebacks": "Chargebacks",
	"menu_settlement": "Conciliação",
	"menu_remittance": "Remessa",
	"menu_consolidated": "Consolidado",
	"menu_payout": "Payout",
	"menu_fee": "Taxas",
	"menu_reserve": "Reserva",
	"menu_notafiscal": "Nota Fiscal",
	"menu_notafiscal_markup": "Nota Fiscal Markup",
	"menu_total_dia": "Totais de Hoje",
	"menu_forecast": "Estimativa",
	"menu_forecast_compare": "Comparativo",
	"menu_time": "Relatório de Alertas",
	"menu_payout_settings": "Configurações",
	"menu_payout_payee": "Favorecidos",
	"menu_payout_payout": "Payouts",
	"menu_payout_movement": "Pay-in/Payout",
	"menu_webhook_config": "Configurações",
	"menu_webhook_history": "Histórico de Webhooks",
	"menu_user": "Usuário",
	"menu_permission": "Permissão",
	"menu_especial_permission": "Permissões Especiais",
	"menu_process_fees_title": "Taxas de Processamento",
	"menu_permission_group": "Grupos de Permissão",
	"menu_permission_merchant": "Permissões por Merchant",
	"menu_permission_campo": "Permissões por Campo",
	"menu_favorecido": "Lista de Clientes",
	"menu_log": "Log",
	"menu_refund_report": "Estornos",
	"menu_revenue": "Faturamento",
	"menu_revenuegrouprange": "Grupo de Faixa de Faturamento",
	"menu_pod_report": "Relatório de PODs",
	"menu_gateway": "Gateway",
	"menu_pagshieldreport": "PagShield Report",
	"menu_remittance_report": "Relatório",
	"menu_products": "Produtos",
	"menu_auto_recurring_title": "PagStream",
	"menu_pagstream_products": "Produtos",
	"menu_auto_recurring_overview": "Visão Geral",
	"menu_auto_recurring_automation": "Automação",
	"menu_auto_recurring_promotion": "Motor de Promoções",
	"menu_auto_recurring_settings": "Configuração",
	"menu_auto_recurring_rules": "Regras",
	"menu_auto_recurring_notification": "Notificações",
	"menu_auto_recurring_customer_area": "Área do Assinante",
	"menu_auto_recurring": "Assinaturas",
	"menu_auto_recurring_frequency": "Ciclos de Cobrança",
	"menu_auto_recurring_shipping_cycle": "Ciclos de Entrega",
	"menu_auto_recurring_reports": "Relatórios",
	"menu_unidade_recebivel": "Recebíveis",
	"menu_pos_contratada": "Pós-Contratados",
	"menu_efeito_contrato": "Efeitos de Contrato",
	"menu_repasse_agendado": "Repasse Agendado",
	"menu_antecipacao_repasse": "Antecipação de Repasse",
	"menu_catalogo": "Catálogo de Produtos",
	"menu_catalogo_categoria": "Categorias",
	"menu_catalogo_produto": "Produtos",
	"menu_fee_remittance": "Taxa Mínima",
	"menu_remittance_proforma": "Proforma",
	"menu_remittance_proformapayment": "Proforma Pagamentos",
	"menu_remittance_consolidatetaxid": "Consolidar CPF/CNPJ",
	"menu_remittance_invoice": "Notas Fiscais(Estrangeiros)",
	"menu_remittance_processment": "Processamento",
	"menu_payment": "Pagamentos",
	"menu_payment_history": "Histórico",
	"menu_payment_setting": "Configurações",
	"menu_payment_setting_config": "Conectores",
	"menu_payment_report": "Relatórios",
	"menu_cost_configuration": "Configuração de Custo",
	"menu_payment_remittance": "Repasses",
	"menu_payment_invoice": "Invoice",
	"menu_invoice_payment": "Invoice Pagamento",

	"searchorder_title": "Buscar Pedido",
	"searchorder_ph_search": "Buscar",
	"searchorder_bt_search": "Buscar",
	"searchorder_bt_insert": "Inserir Ordem",
	"searchorder_bt_export_csv": "Exportar para CSV",
	"searchorder_ph_search_start_date": "Data inicial",
	"searchorder_ph_search_end_date": "Data final",
	"searchorder_order_number": "Número da Ordem",
	"searchorder_email_address": "E-mail",
	"searchorder_submission_date": "Data de Submissão",
	"searchorder_payment_date": "Data de Pagamento",
	"searchorder_internal_number": "Número Interno",
	"searchorder_refund_date": "Data de Estorno",
	"searchorder_td_order": "Número do Pedido",
	"searchorder_td_orders": "Pedidos",
	"searchorder_td_method": "Método",
	"searchorder_td_payment_method": "Método de pagamento",
	"searchorder_td_payment_nupay_type": "Tipo de pagamento NuPay",
	"searchorder_td_date": "Data",
	"searchorder_td_submission_date": "Data de submissão",
	"searchorder_td_expiration_date": "Data de vencimento",
	"searchorder_td_payment_url": "URL de Pagamento",
	"searchorder_td_boleto_url": "URL do Boleto",
	"searchorder_td_payment_url_short": "URL Curta",
	"searchorder_td_action": "Ação",
	"searchorder_td_status": "Status",
	"searchorder_td_status_new": "Status novo",
	"searchorder_td_status_old": "Status anterior",
	"searchorder_td_error": "Código de erro",
	"searchorder_td_abecs_code": "Código de erro da bandeira",
	"searchorder_td_payment_date": "Data de pagamento",
	"searchorder_td_payment_time": "Hora do pagamento",
	"searchorder_td_product": "Produto(s)",
	"searchorder_td_product_service": "Produto(s) / Serviços(s)",
	"searchorder_td_product_list": "Lista de Produtos",
	"searchorder_td_customer_name": "Nome do cliente",
	"searchorder_td_details": "Detalhes",
	"searchorder_td_tax_id": "CPF/CNPJ",
	"searchorder_td_email": "E-mail",
	"searchorder_td_phone": "Telefone",
	"searchorder_td_address": "Endereço",
	"searchorder_td_postal_code": "CEP",
	"searchorder_td_city": "Cidade",
	"searchorder_td_state": "Estado",
	"searchorder_td_amount": "Valor (R$)",
	"searchorder_td_amount_due": "Valor devido",
	"searchorder_td_amount_paid": "Valor pago",
	"searchorder_td_amount_refunded": "Valor devolvido",
	"searchorder_td_sales_channel": "Canal de vendas",
	"searchorder_td_sales_channel_pl_api": "Link de Pagamento (API)",
	"searchorder_td_sales_channel_dashboard": "Link de Pagamento",
	"searchorder_td_sales_channel_remote": "Remote",
	"searchorder_td_sales_channel_pos": "SoftPOS",
	"searchorder_td_fee": "Taxa",
	"searchorder_td_installments": "Parcelas",
	"searchorder_td_brand": "Bandeira do cartão",
	"searchorder_td_ccbrand": "Bandeira do cartão de crédito",
	"searchorder_td_dcbrand": "Bandeira do cartão de débito",
	"searchorder_td_bbrand": "Banco emissor",
	"searchorder_td_brand_details": "Detalhes do cartão",
	"searchorder_td_ccdetails": "Detalhes do cartão de crédito",
	"searchorder_td_ccrestrition": "Restrição",
	"searchorder_td_ccrestriction_block": "Bloqueado em:",
	"searchorder_td_ccrestriction_limit": "Desbloqueio até:",
	"searchorder_td_ccrestriction_code": "Código:",
	"searchorder_td_score_pagshield": "Score atual do PagShield",
	"searchorder_td_pagshield_recommendation": "Recomendação do PagShield",
	"searchorder_td_pagshield_waiting_ps": "Análise em andamento. Por favor, aguarde.",
	"searchorder_td_pagshield_recommendation2": "Pré-autorizado por risco de fraude.",
	"searchorder_td_pagshield_recommendation_info": "O pedido deve ser manualmente revisado para decidir capturá-lo ou cancelá-lo. Para mais informações, acesse o Guia de Revisão Manual de Pedidos Pré-Autorizados na aba \"Recursos\".",
	"searchorder_td_pagshield_history": "Histórico do PagShield",
	"searchorder_td_pagshield_fee": "Taxa do PagShield (R$)",
	"searchorder_td_auth_code": "Código de autorização",
	"searchorder_td_soft_descriptor": "Soft descriptor",
	"searchorder_td_amount_refunded": "Valor estornado",
	"searchorder_td_refund_date": "Data do estorno",
	"searchorder_td_chargeback_info": "Informações de Chargeback",
	"searchorder_td_refund_fee": "Taxa do estorno",
	"searchorder_td_refund_info": "Detalhes do estorno",
	"searchorder_td_recurring": "Recorrência",
	"searchorder_td_auth": "Autorização",
	"searchorder_td_url_retorno": "URL de retorno",
	"searchorder_td_customized_exp": "Vencimento personalizado",
	"searchorder_td_default_exp": "Vencimento padrão",
	"searchorder_td_internal_number": "Número interno",
	"searchorder_td_operation_log": "Log de operação",
	"searchorder_td_pix_auto": "Pix Automático",
	"searchorder_id_pix_auto": "Identificador",
	"searchorder_desc_pix_auto": "Descrição",
	"searchorder_cycle_pix_auto": "Ciclo",
	"searchorder_expir_pix_auto": "Expiração",
	"searchorder_first_pix_auto": "Primeira cobrança",
	"searchorder_min_pix_auto": "Valor mínimo",
	"searchorder_code_pix_auto": "Código",
	"searchorder_bank_pix_auto": "Banco",
	"searchorder_ispb_pix_auto": "ISPB",
	"searchorder_bank_not_found_pix_auto": "Banco não identificado",
	"searchorder_ispb_not_found_pix_auto": "ISPB não recebido",
	"searchorder_error_pix_auto": "Mensagem de erro",
	"searchorder_td_title_number": "Número do título",
	"searchorder_td_extra_param": "Parâmetros extras",
	"searchorder_td_boleto_by": "Boleto via",
	"searchorder_due_date_in": "Vencimento em",
	"searchorder_extend_expiration_date": "Estender data de vencimento",
	"searchorder_extend_expiration_date_by": "Estender data de vencimento até",
	"searchorder_extend_expiration_period": "Estender vencimento em",
	"searchorder_extend_expiration_period_boleto": "Estender vencimento para",
	"searchorder_extend_expiration_invalid": "Período de tempo inválido",
	"searchorder_extend_expiration_success": "Vencimento estendido",
	"searchorder_currency_usd": "US$",
	"searchorder_currency_eur": "€",
	"searchorder_currency_brl": "R$",
	"searchorder_currency_ars": "AR$",
	"searchorder_waiting_for_payment": "Aguardando pagamento",
	"searchorder_failed": "Falhado",
	"searchorder_completed": "Completado",
	"searchorder_captured": "Capturar",
	"searchorder_cancel": "Cancelar",
	"searchorder_refund": "Estornar",
	"searchorder_refund_adicional": "Estorno adicional",
	"searchorder_chargeback": "Chargeback",
	"searchorder_searchon": "Buscar na",
	"searchorder_update": "Atualizar na",
	"searchorder_revert_refund": "Reverter estorno",
	"searchorder_note_bank_acc": "Nota: O titular da conta bancária precisa ser o cliente, e não um terceiro.",
	"searchorder_bank": "Banco",
	"searchorder_branch": "Agência",
	"searchorder_account": "Conta",
	"searchorder_account_type": "Tipo de conta",
	"info_bank_group_pix": "Se o banco não está listado, ele não faz parte do grupo de participantes do Pix.",

	"searchorder_refund_pix_type": "Pix",
	"searchorder_refund_ted_type": "TED",
	"searchorder_refund_transfer_type": "Tipo de transferência",
	"searchorder_customer_pix_key_type": "Tipo de chave",
	"searchorder_customer_pix_key": "Chave de destino",

	"refund_pix_key_type_phone": "Telefone",
	"refund_pix_key_type_taxid": "CPF/CNPJ",
	"refund_pix_key_type_email": "E-mail",
	"refund_pix_key_type_alternative": "Alternativo",

	"searchorder_action_edit": "Editar",
	"searchorder_action_delete": "Deletar",
	"searchorder_action_recreate": "Recriar",
	"searchorder_amount_tobe_refund": "Valor a ser estornado",
	"searchorder_fx_rate_refund": "Valor estimado em ",
	"searchorder_nav_prev": "ANTERIORES",
	"searchorder_nav_next": "PRÓXIMOS",
	"searchorder_suspected_fraud": "Suspeita de fraude",
	"searchorder_action_available": "Nenhuma ação permitida",
	"searchorder_export_without_filter": "Por favor, filtre por ordem, e-mail, data de submissão, data de pagamento ou de reembolso para gerar o relatório a ser exportado.",
	"searchorder_status_boleto": "Status do boleto",
	"searchorder_status_pix": "Consulta Pix",
	"searchorder_boleto_short": "Boleto curto",
	"searchorder_add_payment_link": "Criar Link de Pagamento",
	"searchorder_add_new_order": "Criar Nova Ordem",
	"searchorder_order_created": "Ordem criada",
	"searchorder_cancel_order": "Cancelar",
	"searchorder_refund_order": "Marcar pedido como reembolsado (RP)",
	"searchorder_cc_updated": "CC Alterado.",
	"searchorder_pix_code": "Código do Pix",
	"searchorder_pix_img": "QR Code do Pix",
	"searchorder_ordem_remittance": "Repasse agendado",

	"searchorder_processing_in": "Processado em",
	"searchorder_payment_status": "Status do pagamento",
	"searchorder_recurring_only": "Apenas recorrências",
	"searchorder_pm_bank_transfer":"Transferência/depósito bancário",
	"searchorder_pm_credit_card": "Cartão de crédito",
	"searchorder_pm_debit_card": "Cartão de débito",
	"searchorder_pm_other": "Outros",

	"searchorder_status_pay_completed": "Pagamento completado",
	"searchorder_status_waiting_payment": "Aguardando pagamento",
	"searchorder_status_refund_requested": "Estorno solicitado",
	"searchorder_status_pre_authorized": "Pagamento pré-autorizado",
	"searchorder_status_payment_failed": "Pagamento falhado",
	"searchorder_status_refund_processed": "Estorno processado",
	"searchorder_status_pb_debit_credit": "Débito/crédito da PagBrasil",
	"searchorder_status_payment_rejected": "Pagamento rejeitado",
	"searchorder_status_chargeback": "Chargeback",

	"searchorder_status_listagem_pay_completed": "Completado",
	"searchorder_status_listagem_waiting_payment": "Aguardando pagamento",
	"searchorder_status_listagem_waiting_payment_cc": "Aguardando pagamento",
	"searchorder_status_listagem_refund_requested": "Estorno solicitado",
	"searchorder_status_listagem_pre_authorized": "Pré-autorizado",
	"searchorder_status_listagem_payment_failed": "Falhado",
	"searchorder_status_listagem_refund_processed": "Estorno processado",
	"searchorder_status_listagem_pb_debit_credit": "Débito/crédito da PagBrasil",
	"searchorder_status_listagem_payment_rejected": "Rejeitado",
	"searchorder_status_listagem_chargeback": "Chargeback",

	"searchorder_status_log_refund_rejected": "Estorno rejeitado",
	"searchorder_status_log_captured_order": "Captura solicitada",
	"searchorder_status_log_refund_requested": "Estorno solicitado",
	"searchorder_status_log_cancelled_order": "Cancelamento solicitado",
	"searchorder_status_log_rejected": "Cancelamento solicitado",

	"searchorder_status_listagem_full_pay_completed": "Pagamento completado",
	"searchorder_status_listagem_full_waiting_payment": "Aguardando pagamento",
	"searchorder_status_listagem_full_waiting_payment_cc": "Pagamento realizado mas não capturado ainda",
	"searchorder_status_listagem_full_refund_requested": "Estorno solicitado",
	"searchorder_status_listagem_full_pre_authorized": "Pagamento pré-autorizado mas não capturado ainda",
	"searchorder_status_listagem_full_payment_failed": "Pagamento falhado",
	"searchorder_status_listagem_full_refund_processed": "Estorno processado",
	"searchorder_status_listagem_full_pb_debit_credit": "Débito/crédito da PagBrasil",
	"searchorder_status_listagem_full_payment_rejected": "Pagamento rejeitado",
	"searchorder_status_listagem_full_chargeback": "Chargeback",

	"searchorder_invalid_order": "Caractere inválido no parâmetro 'ordem'.",
	"searchorder_empty_order": "Por favor preencha o campo 'ordem'.",
	"searchorder_empty_product": "Por favor preencha o campo 'produto'.",
	"searchorder_empty_amount": "Por favor preencha o campo 'valor'.",
	"searchorder_empty_installments": "Por favor preencha o campo 'parcelas'.",
	"searchorder_amount_limit": "Valor inválido.",

	"searchorder_cancel_order_msg_pec": "Por favor, confirme que deseja cancelar esta solicitação de pagamento. Após o cancelamento, o cliente não poderá pagar o PEC Flash®, pois o pedido será removido do sistema das agências lotéricas em tempo real.",
	"searchorder_cancel_order_msg_bol": "Por favor, confirme que deseja cancelar esta solicitação de pagamento. Após o cancelamento, o cliente não poderá mais visualizar o boleto.",
	"searchorder_cancel_order_msg_del": "Por favor, confirme que deseja deletar esta ordem.",

	"searchorder_refund_modal_title" : "Solicitar Estorno",
	"searchorder_refund_ckbox_tooltip": "Marque esta checkbox se você estiver reembolsando este pedido devido a uma suspeita de fraude. As informações são inseridas em nosso sistema de prevenção a fraudes e ajudam os usuários do PagShield a evitar fraudes futuras.",

	"searchorder_multi_shipping_refund_title": "Estorno Multi Shipping",
	"searchorder_multi_shipping_refund_description": "Esta ordem possui múltiplos centros de distribuição. Selecione os valores de estorno para cada item individualmente.",
	"searchorder_multi_shipping_refund_note": "Apenas os itens selecionados com valores informados serão processados para estorno.",
	"searchorder_multi_shipping_summary_title": "Resumo do Estorno Multi Shipping",
	"searchorder_multi_shipping_summary_description": "Confirme os estornos selecionados antes de prosseguir.",
	"searchorder_multi_shipping_summary_warning": "Esta ação não pode ser desfeita. Confirme apenas se os valores estão corretos.",
	"searchorder_continue": "Continuar",
	"searchorder_confirm_refund": "Confirmar Estorno",
	"searchorder_total_refund": "Estorno Total",
	"searchorder_enter_refund_amount": "Digite o valor",
	"searchorder_product_s": "produto(s)",
	"searchorder_process_multi_shipping": "Processar Estorno Multi Shipping",

	"searchorder_saldo_insuficiente": "Saldo insuficiente para reembolso.",
	"searchorder_chargeback_requested": "Estorno não permitido. Chargeback foi solicitado.",

	"searchorder_title_order_data": "DADOS DO PEDIDO",
	"searchorder_title_customer_data": "DADOS DO CLIENTE",
	"searchorder_title_payment_information": "INFORMAÇÕES DE PAGAMENTO",
	"searchorder_title_other_information": "OUTRAS INFORMAÇÕES",
	"searchorder_title_beneficiary_information": "BENEFICIÁRIO",

	"searchorder_resend_ipn": "Reenviar IPN",
	"searchorder_complete_payment": "Pagamento completado",

	"searchorder_payer_data": "DADOS DO PAGADOR",

	"search_paymentlink_code": "Código do Link de Pagamento",
	"search_paymentlink_payment_options": "Opções de pagamento",
	"search_paymentlink_url_return": "URL de retorno",
	"search_paymentlink_export_without_filter": "Por favor, filtre por ordem, e-mail, CPF/CNPJ ou data de submissão para gerar o relatório a ser exportado.",
	"search_paymentlink_pm_empty":"Não informado",
	"search_paymentlink_pm_empty_info":"Não informado, todos os métodos de pagamento disponíveis serão inclusos.",
	"search_paymentlink_goto_searchorder": "Buscar Ordem",
	"search_paymentlink_status_pending": "Pendente",
	"search_paymentlink_status_completed": "Completado",
	"search_paymentlink_status_expired": "Expirado",
	"search_paymentlink_status_open": "Aberto",
	"search_paymentlink_status_canceled": "Cancelado",
	"search_paymentlink_cancel_order_msg": "Deseja cancelar essa ordem?",
	"search_paymentlink_extend_period_to" : "Estender vencimento para",
	"search_paymentlink_extend_to" : "Estender para",
	"search_paymentlink_choice_date" : "Escolha uma data",

	"option_order_template" : "Modelo de ordem",
	"option_update_order_no_template" : "Nenhum modelo",
	"option_update_order_chargeback_penalty_fee" : "Taxa de penalidade de estorno",
	"option_update_order_chargeback_reversal" : "Reversão de estorno",
	"option_update_order_double_payment" : "Pagamento em duplicidade",
	"option_update_order_payout_value_retention" : "Transferência de saldos Payout - Retenção de valor",
	"option_update_order_payout_value_release" : "Transferência de saldos Payout - Liberação de valor",
	"option_update_order_process_administrative_fee" : "Cobrança de processos - Taxa administrativa",
	"option_update_order_process_fee" : "Cobrança de processos - Honorários",
	"option_update_order_process_sentence" : "Cobrança de processos - Sentenças",
	"option_update_order_process_procon" : "Cobrança de processos - PROCONS",
	"option_update_order_gateway_fee" : "Taxa de gateway",
	"option_update_order_remittance_fee" : "Taxa de remessa",
	"option_update_order_anticipation_of_receivables" : "Antecipação de recebíveis",
	"option_update_order_termination_fee" : "Taxa de rescisão",

	"ui_title": "Conta",
	"ui_main": "Principal",
	"ui_label_name": "Nome",
	"ui_label_user": "Usuário",
	"ui_label_group": "Grupo",
	"ui_label_account_group_info": "Informações do grupo de conta",
	"ui_label_secretphrase": "Frase secreta",
	"ui_label_token": "Token",
	"ui_label_sessionid": "Session ID",
	"ui_label_ipn_url": "URL do IPN",
	"ui_label_additional_url": "URL adicional",
	"ui_label_api_response_type": "Tipo de resposta da API",
	"ui_label_ipn_response_type": "Tipo de resposta do IPN",
	"ui_label_ipn_asynchronous": "IPN assíncrono",
	"ui_label_ipn_placeholder": "URL que você deseja receber confirmações de pagamento",
	"ui_label_HMAC_key": "Chave HMAC-MD5",
	"ui_label_default_soft_desc": "Soft descriptor padrão",
	"ui_label_information_boleto": "Informação no boleto",
	"ui_label_information_boleto_opt1": "Incluir o número da ordem na descrição do boleto",
	"ui_label_information_boleto_opt2": "Incluir o número da ordem e nome do produto na descrição do boleto",
	"ui_label_maximum_number": "Número máximo de parcelas",
	"ui_label_min_value_installment": "Valor mínimo por parcela",
	"ui_error_min_value_installment": "O valor mínimo de uma parcela é 5,00",
	"ui_label_boleto_bancario": "Boleto bancário válido por",
	"ui_label_pec_valid_for": "PEC Flash válido por",
	"ui_label_pix_valid_for": "Pix válido por",
	"ui_label_pix_fluxo": "Banco principal",
	"ui_label_merchant_type": "Tipo",
	"ui_tooltip_pix_fluxo": "",
	"ui_label_payment_link_valid": "Link de pagamento válido por",
	"ui_label_payment_link_valid_date": "Link de pagamento válido para",
	"ui_label_automatic_cancel": "Cancelamento automático",
	"ui_label_automatic_cancel_day": "Dias úteis após expiração, para cancelar",
	"ui_label_pix_ipn_payer": "Informações do pagador no IPN",
	"ui_label_pix_informacao_pagador": "Substituir informações do pagador",
	"ui_label_pix_itp_open_finance": "Open Finance",
	"ui_label_pix_descriptor": "Prefixo adicionado ao descritor",
	"ui_label_date_decimal_format": "Formato da data e decimal",
	"ui_label_language": "Idioma",
	"ui_label_language_en": "Inglês",
	"ui_label_language_pt": "Português",
	"ui_label_suport_information": "Informação de suporte/contato no boleto bancário",
	"ui_label_suport_information_table": "Informação no boleto",
	"ui_label_payment": "Pagamentos",
	"ui_label_authorized_payment": "Pagamentos autorizados",
	"ui_label_payment_alert": "Alerta de pagamento",
	"ui_label_payment_discount": "Desconto por pagamento",
	"ui_label_payment_discount_range": "Faixa de Desconto",
	"ui_label_payment_discount_range_duplicated": "Valor duplicado.",
	"ui_label_payment_discount_from": "De",
	"ui_label_payment_discount_to": "Até",
	"ui_label_discount_type": "Tipo do desconto",
	"ui_label_value": "Valor",
	"ui_label_fixed_amount": "Valor fixo",
	"ui_label_percentage": "Percentual",
	"ui_label_pagshield": "PagShield",
	"ui_label_pagshield_premium": "PagShield Premium",
	"ui_label_fraud_screening": "Triagem de fraude",
	"ui_label_pre_auth_screening": "Triagem de fraude de ordens de pré-autorização",
	"ui_label_pre_auth_screening_at_creation": "Na criação",
	"ui_label_pre_auth_screening_on_demand": "Sob demanda",
	"ui_label_anti_fraud_service": "ID do serviço de antifraude",
	"ui_label_paypal": "PayPal",
	"ui_label_nupay": "NuPay",
	"ui_label_taxa": 'Taxas',
	"ui_label_fee": "Taxa",
	"ui_label_fee_premium": "Taxa Premium",
	"ui_label_fix_premium": "Taxa fixa Premium",
	"ui_label_public_key": "Chave pública",
	"ui_label_public_key_info": "Usado apenas na página do Link de Pagamento.",
	"ui_label_gateway": "Gateway",
	"ui_label_settlement_cobranca": "Forma de cobrança",
	"ui_label_settlement_cobranca_merchant": "Descontar do Merchant",
	"ui_label_gateway_cobranca": "Forma de cobrança da mensalidade",
	"ui_label_gateway_cobranca_boleto": "Boleto",
	"ui_label_gateway_cobranca_merchant": "Descontar no repasse da seguinte conta de intermediação",
	"ui_label_fix": "Fixo",
	"ui_label_wallet_markup": "Taxa de autenticação com carteiras digitais e 3DS",
	"ui_label_fix_token": "Fixo (Token)",
	"ui_label_number_transaction": "Número de transações >=",
	"ui_label_number_transaction_token": "Número de transações >= (Token)",
	"ui_label_apply_the_fix": "Aplicar o fixo de",
	"ui_label_apply_the_fix_token": "Aplicar o fixo de (Token)",
	"ui_label_key": "Chave",
	"ui_label_terminal_id": "Terminal ID",
	"ui_label_partner_id": "Partner ID",
	"ui_label_authentication": "Autenticação",
	"ui_label_create_date": "Data de criação",
	"ui_label_processing_start_date": "Data início processamento",
	"ui_value_disable_auto_renew": "Desativar renovação",
	"ui_badge_important": "Importante",
	"ui_badge_important_boleto_email": "O estabelecimento precisa estar ciente da opção de renovação automática. Desativar esta opção não irá interromper os lembretes. Para interromper os lembretes, acesse o grupo \"FUNCIONALIDADES\" opção \"E-mail do boleto\".",
	"ui_badge_important_boleto_sms": "O estabelecimento precisa estar ciente sobre a opção de renovação automática. Desativar esta opção não irá interromper os lembretes. Para interromper os lembretes, acesse o grupo \"FUNCIONALIDADES\" opção \"SMS do boleto\".",
	"ui_label_reimburse_fee": "Reembolsar taxa",
	"ui_label_return_transaction_fee": "Devolver a taxa da transação",
	"ui_label_between": "Entre",
	"ui_append_days": "dia(s)",
	"ui_append_hours": "horas(s)",
	"ui_append_minutes": "minuto(s)",
	"ui_label_and": "e",
	"ui_label_refund_after": 'Estorno após',
	"ui_label_and_before": 'e antes',
	"ui_label_valid_for": "Válido para",
	"ui_label_functionalities": "Funcionalidades",
	"ui_label_call_using": "Chamada usando",
	"ui_label_require_pagshield": "Obrigar análise PagShield cartão de crédito",
	"ui_label_recurring_cc": "Recorrência com cartão de crédito",
	"ui_label_recurring_inst": "Recorrência com parcelamento",
	"ui_label_check_taxid": "Verificar CPF/CNPJ",
	"ui_label_settlement_report_option": "Tipo de relatório de conciliação",
	"ui_label_boleto_flash": "Boleto Flash",
	"ui_label_pix_internacional": "Pix para Pagamento Internacional",
	"ui_label_pec_flash": "PEC Flash",
	"ui_label_force_pbtoken": "Forçar Pbtoken",
	"ui_label_invoice_date": "Data da nota fiscal",
	"ui_label_https_boleto": "HTTPS boleto",
	"ui_label_email_boleto": "E-mail do boleto",
	"ui_label_email_pec": "E-mail do PEC Flash",
	"ui_label_email_pagamento": "E-mail de pagamento",
	"ui_label_email_pos": "Recibo de pagamento POS",
	"ui_label_email_pagshopify": "E-mail de pagamento shopify",
	"ui_label_soft_desc_placeholder": "Soft Descriptor de substituição",
	"ui_label_sms_consumido": "Saldo do pacote de SMS",
	"ui_label_email_consumido": "Saldo do pacote de e-mails",
	"ui_label_email_from": "De",
	"ui_label_email_assunto": "Assunto",
	"ui_label_email_template": "Modelo",
	"email_pos_fx_amount": "Valor na moeda",
	"email_pos_fx_rate": "Taxa de câmbio",
	"email_pos_fx_currency": "Moeda da transação",
	"email_pos_template_iof": "IOF",
	"email_template": "Modelo",
	"sms_template": "Modelo",
	"available_placeholders": "Placeholders disponíveis",
	"ui_email_pagamento": "Pagamento",
	"ui_email_pagamento_shopify": "Pagamento Shopify",
	"ui_email_cancel": "Cancelamento de ordem",
	"ui_empty_template": "Modelo vazio",
	"ui_template": "Configurar o modelo",
	"ui_email_sms_confirmation": "Confirmação",
	"ui_email_sms_reminder": "Lembrete",
	"ui_email_sms_both": "Ambos",
	"ui_email_sms_package": "Pacote",
	"ui_email_sms_send_test": "E-mail teste",
	"ui_email_sms_email_sent": "E-mail enviado",
	"email_use_template": "Usar template padrão",
	"voce_deseja_aplicar_template_default": "Você deseja substituir o template atual pelo padrão?",

	"ui_label_webhook_payout": "Payout",
	"ui_label_payoutNotification": "Notificação de payout",
	"ui_label_payoutResend": "Re-envio automático",
	"ui_label_sendFormat": "Formato de envio",
	"ui_label_urlWebhook": "URL do webhook",
	"ui_search_webhook": "Buscar Webhook",
	"ui_unsuccessful_webhook": "Listar todos os webhooks malsucedidos",
	"ui_details_webhook": "Visulizar/Reenviar pagamento",
	"ui_status_success_webhook": "Sucesso",
	"ui_status_fail_webhook": "Falha",
	"ui_status_notcomp_webhook": "Não Completado",
	"ui_clickhere_webhook": "Clique aqui para ver",
	"ui_content_webhook": "Conteúdo",
	"ui_previous_webhook": "Anterior",
	"ui_next_webhook": "Próximo",
	"ui_refresh_webhook": "Recarregar",
	"ui_resend_webhook": "Reenviar Pagamento",
	"ui_label_system": "Sistema",
	"ui_label_json": "JSON",
	"ui_label_post": "POST",
	"ui_label_xml": "XML",
	"ui_label_plain": "Texto plano",
	"ui_label_date_send": "Data",
	"tooltip_payout_resendGroup": 'Se o webhook falhar, nosso sistema enviará um e-mail de alerta para o seu contato técnico (assunto "Urgent: Error posting webhook"). Se você ativar o re-envio automático, nosso sistema tentará re-enviar o webhook falhado, da seguinte forma: - As próximos 7 tentativas ocorrerão a cada 7 minutos. - As próximas 23 tentativas ocorrerão a cada 60 minutos. Se a última tentativa de enviar o webhook falhar, nosso sistema enviará outro e-mail de alerta (assunto "Urgent: Error posting webhook").',
	"tooltip_pagstream_resendGroup": 'Se o webhook falhar, nosso sistema enviará um e-mail de alerta para o seu contato técnico (assunto "Urgent: Error posting webhook"). Se você ativar o re-envio automático, nosso sistema tentará re-enviar o webhook falhado, da seguinte forma: - As próximos 7 tentativas ocorrerão a cada 7 minutos. - As próximas 23 tentativas ocorrerão a cada 60 minutos. Se a última tentativa de enviar o webhook falhar, nosso sistema enviará outro e-mail de alerta (assunto "Urgent: Error posting webhook").',
	"tooltip_payment_resendGroup": 'Se o webhook falhar, nosso sistema enviará um e-mail de alerta para o seu contato técnico (assunto "Urgent: Error posting webhook"). Se você ativar o re-envio automático, nosso sistema tentará re-enviar o webhook falhado, da seguinte forma: - As próximos 7 tentativas ocorrerão a cada 7 minutos. - As próximas 23 tentativas ocorrerão a cada 60 minutos. Se a última tentativa de enviar o webhook falhar, nosso sistema enviará outro e-mail de alerta (assunto "Urgent: Error posting webhook").',
	"tooltip_prov_edit": "Editado",
	"webhook_resend_confirm_part1": "Por favor, clique OK para re-enviar o webhook ID ",
	"webhook_resend_confirm_part2": " para o seu servidor.",

	"ui_label_webhook_pagstream": "PagStream",
	"ui_label_pagstreamNotification": "Notificação de PagStream",
	"ui_label_pagstream_shipping_notification": "Notificação de entrega",
	"ui_label_pagstreamResend": "Re-envio automático",
	"ui_label_pagstream_product_notification": "Notificação de atualização de regra de produto",
	
	"ui_label_webhook_pix": "Pix Automático",
	"ui_label_pix_notification": "Notificação de consentimento Pix Automático",
	"ui_label_pix_resend": "Auto resend",
	"ui_label_pix_settings_webhook": "Webhook URL",

	"ui_label_webhook_payment": "Pagamentos",
	"ui_label_paymentNotification": "Notificação de Pagamentos",
	"ui_label_paymentResend": "Re-envio automático",
	
	"ui_label_webhook_order": "Ordem",
	"ui_label_order_notification": "Notificação de status da Ordem",
	"ui_label_order_resend": "Auto resend",
	"ui_label_order_settings_webhook": "Webhook URL",

	"ui_recurring_template_table": "Modelos de e-mails ao cliente",

	"ui_email_create_recurring": "Ativação - Nova recorrência",
	"ui_email_reminder_recurring": "Lembrete de cobrança de cartão de crédito",
	"ui_email_reminder_recurring_adicional": "Lembrete de cobrança com Link de Pagamento",
	"ui_email_billing_recurring": "Cobrança com Link de Pagamento",
	"ui_email_billing_confirmation": "Confirmação de cobrança",
	"ui_email_cancel_recurring": "Confirmação de cancelamento de recorrência",
	"ui_email_subscriptionupdate": "Confirmação de atualização de recorrência",
	"ui_email_subscriptionpaused": "Confirmação de recorrência pausada",
	"ui_email_reactivate": "Reativação de recorrência",

	"ui_label_link_version": "Versão do link",
	"ui_label_sms_boleto": "SMS do boleto",
	"ui_label_sms_pec": "SMS PEC",
	"ui_label_iframe_signature": "Assinatura do Iframe",
	"ui_label_boleto_node_limit": "Limite de nós no XML do boleto",
	"ui_label_boleto_failed_cc": "Bloquear CCs falhados por",
	"ui_label_blockr": "Bloqueia reembolso",
	"blockr_tooltip": "Este recurso se aplica a todos os métodos de pagamento.",
	"ui_label_block_real_cc": "Bloquear CC real",
	"ui_label_set_cc_pf": "Marcar CC PF",
	"ui_label_cc_info_ipn": "Informação do CC no IPN",
	"ui_label_block_pagshield_amount": "Bloquear valor do PagShield",
	"ui_label_export_report_option": "Tipo de relatório exportado",
	"ui_label_despacho_postal": "Despacho Postal Antecipado",
	"ui_label_despacho_postal_desc": "Taxa postal",
	"ui_label_email_notificacao_cef": "Alerta registro do PEC Flash",
	"ui_label_auto_recurring": "PagStream",
	"ui_label_customer_area": "Área do Assinante",
	"ui_label_customer_area_add_product": "Arraste os produtos aqui para adicionar à Área do Assinante",
	"ui_label_customer_area_remove_product": "Arraste os produtos aqui para remover da Área do Assinante",
	"ui_label_customer_area_available_products": "Disponível para assinaturas na Área do Assinante ",
	"ui_label_single_purchase": "Disponível para compra única na Área do Assinante ",
	"ui_label_creation_rule": "Cria assinatura a partir de uma adição de ordem",
	"ui_label_pagstream_premium": "PagStream Premium",
	"ui_label_pagstream_by_sku": "Regra via SKU",
	"ui_label_pagstream_subscription_creation": "Criação de assinaturas",
	"ui_label_pagstream_subscription_creation_order_approval": "Na aprovação da ordem",
	"ui_label_pagstream_subscription_creation_demand": "Por demanda",
	"ui_label_pagstream_recharge_automatically": "Retentativa de cobrança automática",
	"ui_label_pagstream_subscription_info_wh": "Informações da assinatura no webhook",
	"ui_label_pagstream_shippings": "Separar o envio baseado em um ciclo de entrega",
	"ui_label_auto_rec_email_cancel": "Notificação quando uma recorrência é cancelada",
	"ui_label_all_info_boleto": "Todas as informações no boleto",
	"ui_label_remittance_type": "Tipo de remessa",
	"ui_label_remittance_agent": "Agente de remessa",
	"ui_label_boleto_pay_number": "Código de barras do boleto",
	"ui_label_email_payment_link": "E-mail do Link de Pagamento",
	"ui_label_more": "Mais",
	"ui_label_frequencia": "Frequência do fechamento",
	"ui_label_frequencia_juros": "Frequência para juros",
	"ui_label_remessa": "Remessa",
	"ui_label_pay_in_account": "Conta de ingressos (sem remessa)",
	"ui_label_account_type": "Tipo de conta",
	"ui_label_currency_type": "Moeda",
	"ui_label_greater_than_zero": "Maiores que zero",
	"ui_label_chargeback": "Taxa do chargeback",
	"ui_label_chargeback_tipo": "Tipo de taxa do chargeback",
	"ui_label_spread_pix": "Spread no valor da transação",
	"ui_label_spread": "Spread no valor da transação (como taxa)",
	"ui_label_spreadpos": "Spread no valor líquido (no câmbio)",
	"ui_label_fx_rate_assured": "Momento em que a taxa de câmbio é assegurada",
	"ui_label_fx_rate_assured_spread": "Spread somado na taxa de câmbio atual (PC/CD)",
	"ui_label_fx_rate_assured_spread_risk": "Spread adicional somado quando a taxa de câmbio não está atualizada (PC/CD)",
	"ui_label_fx_rate_fix": "Taxas fixas em USD/EUR",
	"ui_label_fx_rate_assured_spread_refund": "Spread diminuído na taxa de câmbio atual (RP/CB)",
	"ui_label_fx_rate_assured_spread_refund_tooltip": "O spread é adicionado somente se o reembolso for feito em dias posteriores a data de pagamento",
	"ui_label_fx_rate_assured_spread_risk_refund": "Spread adicional diminuído quando a taxa de câmbio não está atualizada (RP/CB)",
	"ui_label_spread_payment": "Spread a ser subtraído da taxa de câmbio atual",
	"ui_label_spread_risk_payment": "Spread adicional a ser subtraído quando a taxa de câmbio não for a atual",
	"ui_label_spread_refund_payment": "Spread a ser adicionado na taxa de câmbio atual",
	"ui_label_spread_risk_refund_payment": "Spread adicional a ser adicionado quando a taxa de câmbio não for a atual",
	"ui_tooltip_payment_spread_refund": "Spread aplicável para reembolsos realizados após 10 minutos da confirmação.",
	"ui_label_min_remittance": "Valor mínimo para repasse",
	"ui_label_payment_spread_confirm": "Spread confirmação",
	"ui_label_payment_spread_refund": "Spread reembolso",
	"ui_label_payment_currencies_and_balances": "Moedas e saldos",
	"ui_label_payment_transaction_fees_by_stage": "Taxas por etapa da transação",
	"ui_label_balance_yesterday": "Saldo de ontem",
	"ui_label_reserve_of": "Reserva de",
	"ui_label_reserve_type": "Tipo da reserva",
	"ui_label_reserve_type_variable": "Variável",
	"ui_label_reserve_type_fixed": "Fixada",
	"ui_label_last": "Últimos",
	"ui_label_reserve_complement": "Reserva complementar",
	"ui_label_remittance_currency": "Moeda da remessa",
	"ui_label_remittance_fee": "Taxa de remessa",
	"ui_label_technical_contact_email": "E-mail(s) do contato técnico",
	"ui_label_operational_contact_email": "E-mail(s) do contato principal da operação",
	"ui_label_refund_contact_email": "E-mail(s) do contato para reembolsos e chargebacks",
	"ui_label_contract_notification_email": "E-mail(s) de notificação referente ao contrato",
	"ui_label_news_contact_email": "E-mail(s) do contato para novidades",
	"ui_label_pod_manager": "Gerente de POD",
	"ui_label_support": "Canal de suporte ao cliente final",
	"ui_label_store_name": "Nome da loja",
	"ui_label_support_email": "E-mail de Suporte",
	"ui_label_store_url": "URL da loja",
	"ui_label_extra_info": "Informação extra",
	"ui_label_partnership": "Parceria",
	"ui_label_risk_rating": "Classificação de risco",
	"ui_label_risk_rating_option_low": "Baixo",
	"ui_label_risk_rating_option_medium": "Médio",
	"ui_label_risk_rating_option_high": "Alto",
	"ui_label_touch_rating": "Classificação de receita",
	"ui_label_compliance_info": "Informações de compliance",
	"ui_label_additional_information_payment_link": "Informação adicional no página do Link de Pagamento (rodapé)",
	"ui_label_maintenance": "Manutenção",
	"ui_label_min_fee": "Taxa mínima de manutenção",
	"ui_label_min_fee_pagstream": "Taxa mínima de manutenção PagStream®",
	"ui_label_start_date_charging": "Data inicial para cobrança da taxa mínima",
	"ui_label_fee_text": "Texto da taxa (max. 200 caracteres)",
	"ui_label_plugin": "Plugin",
	"ui_label_solution_fee": "Taxa da Solução PagBrasil",
	"ui_label_total_amt_fee": "Valor da taxa",
	"ui_label_fee_revenuef": "(faturamento)",
	"ui_label_fee_revenuep": "Taxa Pagstream",
	"ui_label_router_function": "Função de roteamento",
	"ui_label_report": "Relatório",
	"ui_label_daily_report": "Relatório diário",
	"ui_label_pix_roaming_report": "Relatório de Pix para turistas estrangeiros",
	"ui_label_settlement_report": "Relatório consolidado",
	"ui_label_send_email": "E-mail",
	"ui_label_sftp": "SFTP",
	"ui_label_sftp_url": "SFTP URL",
	"ui_label_sftp_port": "SFTP porta",
	"ui_label_sftp_username": "SFTP usuário",
	"ui_label_sftp_password": "SFTP senha",
	"ui_label_sftp_path": "SFTP caminho",
	"ui_label_daily_report_option": "Opções no relatório diário",
	"ui_label_daily_taxid": "CPF/CNPJ",
	"ui_label_daily_commission_id": "ID de comissionamento (Computop)",
	"ui_label_daily_translate_payment": "Método de pagamento (completo)",
	"ui_label_daily_translate_status": "Status da ordem (completo)",
	"ui_label_send_ipn_credentials": "Enviar IPN usando as credenciais de",
	"ui_label_redirect_payment_method": "Redirecionar o método de pagamento para",
	"ui_label_comission": "Comissão",
	"ui_label_comission_account": "Conta para comissão",
	"ui_label_comission_rate": "Taxa de comissão",
	"ui_label_fixed_fee_transaction": "Taxas fixas por transação",
	"ui_label_variable_fee_transaction": "Taxas variáveis por transação",
	"ui_label_associated_remittance": "Remessa associada",
	"ui_label_associated_remittance_account": "Contas de remessas associadas",
	"ui_label_boleto": "Boleto Express",
	"ui_label_cartao_credito": "Cartão de Crédito",
	"ui_label_juros_cc": "Juros do CC",
	"ui_label_min": "Mín",
	"ui_label_fee_a_vista": "À vista",
	"ui_label_fee_parcelado_2a6": "Taxa adicional de parcelamento: 2 a 6 parcelas",
	"ui_label_fee_parcelado_7a12": "Taxa adicional de parcelamento: 7 a 12 parcelas",
	"ui_label_fee_parcelado_7a24": "Taxa adicional de parcelamento: 7 a 24 parcelas",
	"ui_label_taxa_juros_cc": "Taxa base de antecipação",
	"ui_label_exemplo_juros": "Taxa de antecipação por nro. de parcelas",
	"ui_label_cartao_debito": "Cartão de Débito",
	"ui_label_bank_transfer": "Transferência bancária",
	"ui_label_refund": "Estorno/Chargeback",
	"ui_label_cartoes_dc": "Cartão de crédito/débito",
	"ui_label_boleto_outros": "Boleto e outros",
	"ui_label_invoice_information": "Informação para a fatura",
	"ui_label_name_invoice": "Nome na fatura",
	"ui_label_name_mcc_cod": "Código MCC",
	"ui_label_alert_mcc_cod": "MCC de risco, informe ao compliance.",
	"ui_label_category": "Categoria",
	"ui_label_cnpj": "VAT/CNPJ",
	"ui_label_razao_social": "Razão social",
	"ui_label_pais": "País",
	"ui_label_estado": "Estado",
	"ui_label_cidade": "Cidade",
	"ui_label_cep": "CEP",
	"ui_label_endereco": "Endereço",
	"ui_label_numero": "Número",
	"ui_label_complemento": "Complemento",
	"ui_label_bairro": "Bairro",
	"ui_label_contrato_assinado": "Data de início da vigência do Contrato",
	"ui_label_last_kyc": "Última atualização do KYC",
	"ui_label_account_contact_name": "Nomes de contato da conta",
	"ui_label_salutation_email": "Saudação para e-mail",
	"ui_label_account_contact_email": "E-mail(s) do contato financeiro",
	"ui_label_bank_account": "Conta bancária (rodapé da fatura)",
	"ui_label_email": "E-mail",
	"ui_label_receive_notification_update": "Receber notificações de atualizações em serviços",
	"ui_label_receive_notification_chargeback": "Receber notificações de chargebacks e estornos rejeitados",
	"ui_label_notification": "Notificações",
	"ui_cf_password": "A nova senha e a confirmação não correspondem.",
	"ui_label_gateway_zero_auth": "Zero Auth",

	"ui_label_invoice_bank": "Banco",
	"ui_label_invoice_branch": "Agência",
	"ui_label_invoice_account": "Conta corrente",
	"ui_label_invoice_taxid": "CNPJ",
	"ui_label_invoice_favorecido": "Favorecido",
	"ui_label_invoice_beneficiary": "Beneficiário",
	"ui_label_invoice_bank_name": "Nome do banco",
	"ui_label_invoice_branch_xb": "Agência",
	"ui_label_invoice_account_xb": "Conta corrente",
	"ui_label_invoice_bank_code": "Código do banco",
	"ui_label_invoice_swift_code": "código Swift",
	"ui_label_invoice_aba_routing_number": "Número de roteamento ABA",
	"ui_label_invoice_iban_number": "Número IBAN",
	"ui_label_invoice_additional_detail": "Detalhes adicionais",

	"fx_rate_assured_remittance": "Repasse",
	"fx_rate_assured_transaction": "Transação paga em BRL",
	"fx_rate_assured_created": "Transação submetida em USD/EUR",

	"ui_label_notification_update": "Atualizações",
	"ui_label_notification_chargeback": "Chargebacks e estornos rejeitados",

	"ui_label_boleto_email_service": "Serviço de e-mail",
	"ui_label_nro_remaining_email": "Nro. de e-mails restantes de crédito",
	"ui_label_subscription": "Assinatura",
	"ui_label_auto_renew": "Renovação automática",
	"ui_label_nro_remaining_sms": "Nro. de SMS restantes de crédito",
	"ui_label_boleto_sms_service": "Serviço de SMS",
	"ui_label_password_recovery": "Recuperação de senha",
	"ui_label_configuration": "Configuração",
	"ui_label_answer": "Resposta",
	"ui_label_security_question": "Pergunta de segurança",
	"ui_label_current_password": "Senha atual",
	"ui_label_new_password": "Nova senha",
	"ui_label_payment_link": "Link de Pagamento",
	"ui_label_boleto_tab": "Boleto",
	"ui_label_logo_boleto": "Seu logo",
	"ui_label_logo_boleto_placeholder": "Nenhum arquivo selecionado",
	"ui_label_logo_boleto_table": "Logo",
	"ui_label_abreviacao": "Abreviatura do gerente de conta",
	"ui_label_account_manager": "Gerente da conta",
	"ui_label_shop_code": "Código da loja",
	"ui_label_resend_ipn_not_compliant": "Reenviar IPN incompatível",
	"ui_label_create_product_on_insert": "Criar produto na inserção",
	"ui_label_create_product_on_insert_if_not_exists": "caso não exista",
	"ui_label_distribution_center": "Centro de distribuição",
	"ui_label_pod_routine": "Rotina de POD",
	"ui_label_refundadicional": "Reembolso adicional",
	"ui_label_send_customer_email": "Enviar email do cliente no IPN",
	"ui_label_manual": "Manual",
	"ui_label_default": "Padrão",
	"ui_label_return_refund_order": "Retorno de reembolso de ordem",
	"ui_label_samsungpay": "Samsung Pay",
	"ui_label_refund_by": "Reembolso via",
	"ui_label_both": "Ambos",
	"ui_label_pix": "Pix",
	"ui_label_placeholders_service": "Placeholders",
	"ui_label_placeholders_store_name": "Nome da loja",
	"ui_label_placeholders_store_contact": "Contato da loja",

	"ui_label_repasse_agendado": "Agenda de Liberação de Repasses",
	"ui_label_days_added_default": "Dias adicionados por padrão",

	"accremitsch_payment_method": "Método de Pagamento",
	"accremitsch_num_parcela": "Parcelas",
	"accremitsch_num_dia": "Dias(s) Adicionados",

	"ui_label_enabled_payments": "Shopify",
	"ui_label_enabled_payments_desc": "Formas de pagamento",
	"shopify_payments_pec": "PEC Flash",
	"shopify_payments_boleto": "Boleto Bancário",
	"shopify_payments_credit_card": "Cartão de Crédito",
	"shopify_payments_debit_card": "Cartão de Débito",
	"shopify_payments_banco_brasil": "Banco do Brasil Comércio Eletrônico",
	"shopify_payments_bradesco": "Bradesco Comércio Eletrônico",
	"shopify_payments_banrisul": "Banricompras",
	"shopify_payments_itau": "Itaú Shopline",
	"shopify_payments_paypal": "PayPal",
	"shopify_payments_pix": "Pix",

	"shopify_fields_style": "Estilo",
	"shopify_fields_logo": "Logo",
	"shopify_fields_contact_channel": "Canal de contato",
	"shopify_fields_transparent_checkout": "Checkout transparente",
	"shopify_fields_partial_status_fulfillment": "Status parcial do fulfillment",
	"shopify_fields_concatened_product_sku": "SKU do produto concatenado",
	"shopify_fields_update_checkout_note": "Atualizar nota de checkout",
	"shopify_fields_multiple_payments": "Permitir pagamento com 2 métodos",
	"shopify_fields_multiple_payments_combination": "Combinações de pagamento permitidas",
	"shopify_fields_card_to_card": "Cartão + Cartão",
	"shopify_fields_card_to_pix": "Cartão + Pix",
	"shopify_fields_pix_order_pending": "Pedido de Pix pendente",
	"shopify_fields_boleto_order_pending": "Pedido de Boleto pendente",
	"shopify_fields_only_update_order": "Apenas atualizar o pedido",
	"shopify_fields_get_company_name": "Obter dados do CNPJ",
	"shopify_fields_format_address_tiny": "Formatar endereço abreviado",
	"shopify_fields_save_original_attributes": "Salvar atributos originais",

	"shopify_fields_checkout_version": "Versão do checkout",
	"shopify_fields_merchant_url": "URL do merchant",
	"shopify_fields_verify_cep": "Valida CEP",
	"shopify_fields_cpfcnpj": "CPF/CNPJ no campo empresa",
	"shopify_fields_phone_mask": "Máscara do campo telefone",
	"shopify_fields_activate_nupay_message": "Ativar mensagem NuPay",
	"shopify_fields_enable_message_nupay": "Você escolhe pagar com saldo da conta, crédito ou com limite adicional de NuPay em até 36x.",
	"shopify_fields_disabled_message_nupay": "Você será redirecionado para uma página de pagamento.",
	"shopify_fields_company_name": "Campo de razão social",
	"shopify_fields_auto_recurring": "Recorrência automática",
	"shopify_fields_force_fallback": "Forçar fallback",
	"shopify_fields_additional_attributes": "Atributos adicionais",
	"shopify_options_disabled": "Desabilitado",
	"shopify_options_enabled": "Habilitado",
	"shopify_options_enabled_with_attributes": "Habilitado com atributos adicionais",
	"shopify_options_enabled_cpfcnpj": "Habilitado CPF/CNPJ",
	"shopify_options_enabled_cpf": "Habilitado apenas CPF",
	"shopify_options_enabled_cnpj": "Habilitado apenas CNPJ",
	"shopify_options_checkout_v2": "Versão 2",
	"shopify_options_checkout_v3": "Versão 3 (recomendada)",
	"shopify_options_creditcard_brand": "Bandeira do cartão de crédito",
	"shopify_options_creditcard_installments": "Parcelas do cartão de crédito",
	"shopify_options_boleto_url": "URL do boleto",
	"shopify_options_inscription": "Inscrição estadual",
	"shopify_tooltip_merchant_url": "Deverá ser informada a URL no formato \"store.myshopify.com\".",
	"shopify_tooltip_note_attributes": "Atributos que serão adicionados ao campo note_attributes da ordem.",
	"shopify_pagstream_settings": "Configurações PagStream",
	"shopify_general_settings": "Configurações gerais",
	"shopify_general_settings_internal": "Configurações gerais - interno",
	"shopify_frequency_radio_button_color": "Cor do botão de recorrência",
	"shopify_frequency_select_button_color": "Cor do seletor de frequência:",
	"shopify_frequency_select_font_color": "Cor da font do seletor de frequência:",
	"shopify_frequency_select_radius": "Arredondamento do seletor de frequência:",
	"shopify_frequency_select_border": "Borda do seletor de frequência:",
	"shopify_frequency_select_border_color": "Cor da borda do seletor de frequência:",
	"shopify_pagstream_recurrence_text": "Texto de recorrência:",
	"shopify_pagstream_frequency_text": "Texto de frequência:",
	"shopify_pagstream_frequency_empty": "Selecione a frequência e preencha o texto de visualização",
	"shopify_pagstream_frequency_registered": "Frequência já cadastrada",
	"shopify_pagstream_first_option_texts": "Textos da primeira opção",
	"shopify_pagstream_option_label_text": "Texto da label",
	"shopify_pagstream_second_option_texts": "Textos da segunda opção",
	"shopify_pagstream_warning_text": "Texto informativo:",
	"shopify_pagstream_general_styles": "Estilos gerais",
	"shopify_pagstream_selected_option_styles": "Estilos da opção selecionada",
	"shopify_pagstream_option_border_color": "Cor da borda das opções:",
	"shopify_pagstream_option_font_color": "Cor da fonte das opções:",
	"shopify_pagstream_radio_color": "Cor do botão radio:",
	"shopify_frequency_warning_text_color": "Cor do texto informativo:",
	"shopify_frequency_options_border_radius": "Arredondamento da borda das opções:",
	"shopify_frequency_selected_option_bg": "Cor de fundo da opção selecionada:",
	"shopify_frequency_selected_option_bg_not_selected": "Cor de fundo da opção não selecionada:",
	"shopify_frequency_selected_option_border_color": "Cor da borda da opção selecionada:",
	"shopify_frequency_selected_option_font-color": "Cor da fonte da opção selecionada:",
	"shopify_tooltip_frequency_list": "Com o mouse sobre as opções de frequência, arraste e solte para alterar a ordem de exibição.",
	"shopify_add_discount": "Adicionar desconto",
	"shopify_edit_discount": "Editar desconto",
	"shopify_method_registered": "Método de pagamento já possui desconto cadastrado",
	"shopify_method_not_registered": "Você deve preencher todos os campos.",
	"shopify_pagstream_premium_subdomain": "Subdomínio PagStream Premium",
	"shopify_pagstream_premium_invalid_subdomain": "Insira um subdomínio válido.",

	"shopify_fields_frequency_pagstream": "Assinatura com um clique",
	"shopify_fields_all_products_pagstream": "Habilitar assinatura para todos os produtos",
	"shopify_fields_frequency_code_pagstream": "Código da frequência",
	"shopify_fields_text_frequency_pagstream": "Texto para visualização",
	"shopify_fields_options_frequency_pagstream": "Opções de frequência adicionadas",
	"shopify_button_add_frequency": "Adicionar Frequência",
	"shopify_button_update_frequency": "Alterar Frequência",
	"shopify_recurring_payment_options": "Métodos de pagamento para assinatura",
	"shopify_show_apple_pay": "Apple Pay para assinatura",
	"shopify_one_installment_recurring": "Parcela única para assinatura",
	"shopify_cc_tokenization": "Tokenização",
	"shopify_apply_discount_into_checkout": "Aplicar desconto no checkout (app legado)",
	"shopify_recurring_methods_overwrite": "Priorizar métodos de assinatura",
	"shopify_recurring_create_recurring_by_catalog": "Criar recorrente por catálogo",
	"shopify_recurring_fixed_billing_date": "Data de cobrança fixa",
	"shopify_recurring_catalog_base_day": "Dia base do catálogo",
	"shopify_recurring_create_recurring_on_current_month": "Criar recorrência no mês atual",
	"shopify_recurring_recurring_installments": "Parcelas na recorrência",
	"shopify_recurring_min_value_installments_recurring": "Valor mínimo das parcelas da recorrência",

	"shopify_recurring_methods_tooltip": "Habilitando esta opção, quando houver um checkout com produtos de assinatura e compras normais, os métodos de pagamentos para assinatura serão priorizados e exibidos para o cliente.",
	"shopify_discount_payment_method": "Desconto por forma de pagamento",
	"shopify_discount_payment_config": "Método de pagamento",
	"shopify_discount_payment_percentage": "Porcentagem",

	"ui_label_status_conta": "Status da conta",
	"status_conta_fechada": "Fechada",
	"status_conta_online": "Online",
	"status_conta_bloqueada": "Bloqueada",

	"ui_label_preview": "Prévia",
	"ui_logo_requirement": "Requerimentos: Use um arquivo PNG ou SVG com resolução máxima de 170 x 35 pixels e com o fundo transparente.",
	"ui_error_upload_logo": "Erro ao enviar o logo!",
	"ui_logo_removed": "Logo removido dos seus boletos!",
	"ui_logo_removed_direct": "Logo removido",
	"ui_error_remove_logo": "Erro removendo o logo!",

	"ui_account_sub": "Configurações",
	"ui_email_title": "E-mail/SMS",
	"ui_config_title": "Configurações Admin.",
	"ui_customer_area_config_title": "Área do Assinante",
	"ui_fee_title": "Taxas da Conta",
	"ui_user_config_title": "Perfil",
	"ui_user_list_title": "Lista de Usuários",
	"ui_blocklist_pix_roaming_title": "Lista de bloqueio de Pix para turistas estrangeiros",
	"ui_obt": "Transferência Bancária Online",

	"ui_tooltip_pass_recovery": "Atualize sua pergunta e resposta de segurança, que você irá precisar para resetar a sua senha. A pergunta e resposta de segurança precisam ter no mínimo 8 caracteres.",
	"ui_placeholder_new_pass": "Digite sua nova senha se você quer alterá-la",
	"ui_label_confirm_new_password": "Confirme sua nova senha",
	"ui_placeholder_security": "Insira sua nova pergunta de segurança se você quer alterá-la",
	"ui_placeholder_answer": "Informe sua resposta se você está alterando sua pergunta de segurança",

	"ui_alert_vencpec_limit": "O número de dias limite do vencimento do PEC Flash é entre 0 e 5",
	"ui_alert_freq_curremit_q": "Você não pode selecionar \"Semanas alternadas\" como frequência e 'EUR' ou 'USD' como moeda de remessa.",
	"ui_alert_freq_curremit_z": "Você não pode selecionar \"Duas vezes ao mês\"  como frequência e 'BRL' como moeda de remessa.",

	"ui_erro_maxlength": "O campo {fieldName} excedeu o tamanho máximo",
	"ui_erro_minlength": "O campo {fieldName} não atende ao tamanho mínimo",
	"ui_erro_empty": "O campo {fieldName} deve ser preenchido",
	"ui_erro_invalid_postal_code": "CEP inválido",
	"ui_erro_invalid_cnpj": "VAT/CNPJ inválido",
	"ui_erro_invalid_branch": "Agência inválida",
	"ui_erro_invalid_account": "Conta inválida",
	"ui_erro_invalid_taxid": "CPF/CNPJ inválido",
	"ui_erro_invalid_phone_number": "O {fieldName} deve ser um número de telefone válido",

	"ui_label_fee_installment_shopify": "Adicionar percentual de juros em cada parcela",
	"ui_label_installment_fee_shopify_installments": "Qtd. mínima de parcelas para acrescentar os juros ao valor",
	"ui_label_type_of_fee_shopify": "Juros a ser acrescentado",
	"ui_label_type_of_fee_shopify_automatic": "Calculado automaticamente",
	"ui_label_type_of_fee_shopify_manual": "Manualmente definido",
	"ui_for_shopify": "Somente para Shopify",
	"ui_for_shopify_iframe": "Somente para iFrame/plugin",
	"ui_for_paylink_plugin": "Somente para link de pagamento/plugin",
	"ui_help_fee_installment": "Exemplo para um pedido de BRL 100:",

	"ui_alert_field": "Por favor, preencha todos os campos.",
	"ui_alert_day_limit_999": "Os dias úteis para cancelamento automático devem ser entre 1 e 999.",

	"ui_super_config_title": "Configuração",
	"ui_label_create": "Criar",
	"ui_label_save": "Salvar",
	"ui_label_save_future": "Atualizar cobranças futuras",
	"ui_label_correios": "Correios",
	"ui_label_usuario_correios": "Usuário Correios",
	"ui_label_senha_correios": "Senha Correios",
	"ui_label_cartao_postagem_correios": "Cartão de Postagem Correios",
	"ui_label_valor_disponivel_despacho": "Saldo do Despacho Postal",
	"ui_label_valor_alerta_despacho": "Alerta de Saldo",
	"desc_alerta_despacho": "Quando o 'Saldo do Despacho Postal' for inferior ao 'Alerta de Saldo', o sistema criará um ticket de suporte.",

	"ui_label_autorec_day_anticipate_pl": "Dias antes da cobrança para criação do Payment Link",
	"ui_label_autorec_day_anticipate_pl_desc": "Defina em quantos dias o Payment Link deve ser criado antes do vencimento de uma recorrência.",
	"ui_label_auto_recurring_multiple": "Criar uma recorrência para",
	"ui_label_auto_recurring_multiple_opcao1": "Somente a primeira regra executada",
	"ui_label_auto_recurring_multiple_opcao2": "Todas as regras executadas",
	"ui_label_auto_recurring_multiple_desc": "Se o produto da ordem for compatível com mais de uma regra, isso vai criar mais de uma recorrência.",
	"ui_label_auto_recurring_days_to_reminder": "Nro. de dias antes do vencimento para envio do lembrete",
	"ui_label_autorecurring_auto_update": "Sobrescrever todas as próximas cobranças",
	"ui_label_pagstream_multiple_card": "Permitir cobrança em todos os cartões do cliente",
	"ui_label_pagstream_allow_overdue": "Permitir atraso de recorrências",
	"ui_label_pagstream_max_overdue": "Número máximo de atrasos permitidos",

	"ui_create_konduto_account": "Criar Conta na Konduto",
	"ui_valida_create_konduto": "Há uma alteração pendente. Salve as alterações para depois realizar o cadastro de conta da Konduto.",

	"ui_label_marketplace": 'Marketplace',
	"ui_label_seller": 'Vendedor',
	"marketplace": 'Marketplace',
	"master": 'Master',
	"ui_label_merchant": "Merchant",
	"ui_label_percentual": "Split",
	"split_value_invalid": "Valor de split inválido.",
	"ui_label_revenue_group": "Grupo de faturamento",

	"ui_label_markup": "Markup",
	"ui_label_markup_nota_fiscal": "Nota Fiscal",
	"markup_merchant": "Merchant de Markup",
	"ui_label_markup_fix": "Markup Fix",
	"markup_notafiscal_merchant_alert": "Quando a opção 'Nota Fiscal' for marcada como 'SIM', você precisa selecionar o 'Merchant de Markup'.",

	"label_cc_authentication": "Autenticação de Cartão de Crédito",
	"label_dc_authentication": "Autenticação de Cartão de Débito",
	"label_cc_action_on_auth_fail": "Ação quando não autenticar",
	"label_dc_action_on_auth_fail": "Ação quando não autenticar",
	"label_addtoken_available": "addToken",
	"return_error":	"Retornar erro",
	"proceed_to_authorization":	"Prosseguir para autorização",

	"sr_title": "Relatórios de Conciliação",
	"sr_tab_transfer": "Repasse",
	"sr_tab_sales": "Vendas",
	"sr_tab_settlement": "Conciliação",
	"sr_tab_transfer_title": "Relatórios de Repasse",
	"sr_tab_sales_title": "Relatórios de Vendas",

	"sr_previsao": "Mostrar Valores Preliminares",
	"sr_update_reserve_amount": "Atualizar o valor da reserva",
	"sr_inform_new_reserve": "Por favor informe o novo valor da reserva",
	"sr_update_processed_amount": "Atualizar o valor processado",
	"sr_inform_new_processed": "Por favor informe o novo valor processado",
	"sr_date": "Data",

	"sr_report_date": "Data Relatório",
	"sr_sales": "Vendas",
	"sr_amount_paid": "Valor Pago",
	"sr_amount_gross": "Valor Bruto",
	"sr_fee": "Taxas",
	"sr_refund": "Estornos",
	"sr_discounts": "Descontos",
	"sr_chargeback": "Chargebacks",
	"sr_amount_net": "Valor Líquido",
	"sr_remittance": "Remessa",
	"sr_reserve": "Reserva",
	"sr_transfer": "Repasse",
	"sr_transfer_date": "Data do Repasse",
	"sr_transfer_sales_net": "Vendas Liq.",
	"sr_previous_reserve": "Reserva Ant.",
	"sr_transfer_discounts": "Descontos",
	"sr_processed": "Processado",
	"sr_debits": "Débitos",
	"sr_simulate": "Simular",

	"sr_report": "Relatório",
	"sr_payout": "Payout",
	"sr_invoice": "Fatura",
	"sr_transaction": "Transação",
	"sr_transactions": "Transações",
	"sr_creditdebit": "Crédito/Débito",
	"sr_amount_last_reserve": "Reserva já liberada",
	"sr_amount_reserve_retained": "Reserva atual retida",
	"sr_estimated": "Estimativa baseada em transações até ",
	"sr_preliminary": " (valores preliminares).",
	"sr_results": "Resultados",
	"sr_show_future_values": "Mostrar Valores Preliminares",
	"sr_download": "Download",
	"sr_estimate_until": "Estimativa até ",
	"sr_rs": " (R$)",
	"sr_usd": " (US$)",
	"sr_eur": " (€)",
	"sr_brl": " (BRL)",

	"sr_tooltip_report_date": "Data do Relatório",
	"sr_tooltip_transaction": "Vendas",
	"sr_tooltip_amount_paid": "Valor Pago",
	"sr_tooltip_amount_gross": "Valor Bruto",
	"sr_tooltip_fee": "Taxas",
	"sr_tooltip_creditdebit": "Crédito/Débito",
	"sr_tooltip_refund": "Estornos",
	"sr_tooltip_chargeback": "Chargebacks",
	"sr_tooltip_amount_net": "Valor Líquido",
	"sr_tooltip_remittance": "Remessa",
	"sr_tooltip_reserve": "Reserva",
	"sr_tooltip_processed": "Processado",
	"sr_tooltip_transfer_date": "Data do Repasse",
	"sr_tooltip_transfer": "Repasse",
	"sr_tooltip_download": "Download",

	"sr_modal_information_title_30_days": "30 dias",
	"sr_modal_information_title_180_days": "180 dias",
	"sr_modal_information_how_calculation": "Como o cálculo é feito",
	"sr_modal_information_content_A": "O total dos pagamentos dos últimos 30 (trinta) dias.",
	"sr_modal_information_content_B": "A média mensal dos pagamentos nos últimos 180 (cento e oitenta) dias, desde que tenha havido mais de 30 (trinta) dias com pagamentos, considerando apenas os dias com pagamentos.",
	"sr_modal_information_content_C": "O total dos pagamentos nos últimos 180 (cento e oitenta) dias quando houver menos de 30 (trinta) dias com pagamentos no período de 180 (cento e oitenta) dias.",
	"sr_modal_information_observation_C": "* Aplica-se somente quando há menos de 30 dias de vendas nos últimos 180 dias.",

	"sr_modal_formula_total_money_30_days": "R$ Total (30 dias)",
	"sr_modal_formula_total_money_180_days": "R$ Total (180 dias)",
	"sr_modal_information_percent_reserve": "% reserva",
	"sr_modal_information_days_with_sales": "Qtd. de dias c/ vendas",

	"sr_send_to_pbf_title": "Dados enviados para o Pré Repasse",
	"sr_send_to_pbf_date": "Data pagamento",
	"sr_send_to_pbf_merchant": "Merchant",
	"sr_send_to_pbf_value": "Valor",
	"sr_send_to_pbf_tax": "Taxa",
	"sr_send_to_pbf_debit": "Débito",
	"sr_all_payments_total": "Total dos Pagamentos",

	"dr_title": "Relatórios de Vendas",
	"dr_boleto_express": "Boleto Express",
	"dr_boleto_flash": "Boleto Flash",
	"dr_credit_card_details": "Detalhes de Cartão de Crédito",

	"dr_apple_pay_details": "Detalhes de Apple Pay",
	"dr_google_pay_details": "Detalhes de Google Pay",
	"dr_samsung_pay_details": "Detalhes de Samsung Pay",

	"dr_payment_method": "Método de Pagamento",
	"dr_tipo": "Tipo",
	"dr_qty_total": "Qtd Total",
	"dr_preauth_request": "Pré-Aut. Submetidas",
	"dr_preauth_successful": "Pré-Aut. Sucesso",
	"dr_capture_requests": "Capturas Solicitadas",
	"dr_completed_successful": "Completados",
	"dr_conversion_rate": "Taxa de Conversão",
	"dr_success_rate": "Taxa de Sucesso",
	"dr_revenue": "Faturamento",
	"dr_refund": "Estornos",
	"dr_chargeback": "Chargebacks",
	"dr_fee": "Taxas",
	"dr_net_total": "Total Líquido",
	"dr_chargeback_amount_paid": "Índice de Chargeback - Cartões de Crédito - Baseado no valor pago / mês da venda",
	"dr_chargeback_submission_month": "Índice de Chargeback - Cartões de Crédito - Baseado no número de transações / mês da venda",
	"dr_chargeback_chargeback_month": "Índice de Chargeback - Cartões de Crédito - Baseado no número de transações / mês do chargeback",
	"dr_select": "Selecione",
	"dr_day": "Dia",
	"dr_month": "Mês",
	"dr_period": "Período",
	"dr_conversion_rate_info": "Transações completadas com sucesso (não inclui pré-autorizadas).",
	"dr_success_rate_info": "Transações aprovadas com sucesso.",
	"dr_col_compress_title": "Dados de pré-autorizações",
	"dr_modal_chargeback_legend_critical_rate": "Taxa crítica de chargeback",
	"dr_modal_chargeback_legend_high_rate": "Taxa elevada de chageback",

	"cr_title": "Relatórios de Comissões",
	"cr_payment_method": "Método de Pagamento",
	"cr_total_fee": "Taxas Totais (sem spread)",
	"cr_commissionable_fee": "Taxa Comissionável",
	"cr_commission_rate": "Taxa da Comissão",
	"cr_commission": "Comissão",

	"gr_title": "Relatórios Gráficos",
	"gr_merchant": "Estabelecimento",
	"gr_type": "Tipo",
	"gr_stats": "Estatísticas",
	"gr_details": "Detalhes",
	"gr_filters": "Filtros",
	"gr_amount_paid": "Valor Pago",
	"gr_payment_rejected": "Pagamento Rejeitado",
	"gr_chargebacks": "Chargebacks",
	"gr_payment_failed": "Pagamento Falhado",
	"gr_refunds": "Estorno",
	"gr_pagbrasil_dc": "Débito/Crédito da PagBrasil",
	"gr_gateway": "Gateway",
	"gr_measures": "Métricas",
	"gr_value": "Valor (R$)",
	"gr_quantity": "Quantidade",
	"gr_fee": "Taxa (R$)",
	"gr_mes_atual": "Mês Atual",

	"ar_measures": "Métricas",
	"ar_percentage": "Porcentagem",
	"ar_empty_chart": "Sem dados.",
	"ar_value": "Valor (R$)",
	"ar_quantity": "Quantidade",
	"ar_rec_new": "Novas assinaturas",
	"ar_rec_renewed": "Renovações efetuadas",
	"ar_rec_pending": "Assinaturas pendentes",
	"ar_rec_canceled": "Assinaturas canceladas",
	"ar_active": "Ativas",
	"ar_pending": "Pendentes",
	"ar_pending_first_payment": "Aguardando primeiro pagamento",
	"ar_overdue": "Atrasadas",
	"ar_inactive": "Inativas",
	"ar_expired": "Expiradas",
	"ar_paused": "Pausadas",
	"ar_attempts": "Tentativas",
	"ar_conversions": "Conversões",
	"ar_generated": "Gerados",
	"ar_converted": "Convertidos",
	"ar_not_converted": "Não convertidos",
	"ar_predict_new": "Novas assinaturas",
	"ar_predict_renew": "Renovações efetuadas",
	"ar_predict_predicted": "Renovações previstas",
	"ar_predict_cancelled": "Assinaturas canceladas",
	"ar_predict_expired": "Assinaturas expiradas",
	"ar_predict_paused": "Assinaturas pausadas",
	"ar_cancellation_lack_of_necessity_reason": "Não desejo mais receber o produto/serviço",
	"ar_cancellation_low_satisfaction_reason": "Não estou satisfeito com o produto/serviço",
	"ar_cancellation_regret_reason": "Me arrependi da compra",
	"ar_cancellation_another_reason": "Outro motivo",
	"ar_cancellation_by_system": "Pelo sistema",
	"ar_cancellation_by_user": "Por um usuário do dashboard",
	"ar_chart_period": "Eventos por data",
	"ar_chart_cancellation": "Cancelamentos",
	"ar_chart_pl_conversion": "Link de pagamento",
	"ar_chart_recharge": "Retentativas de cobrança",
	"ar_chart_event": "Eventos",
	"ar_chart_conversion": "Cobranças de recorrência",
	"ar_chart_subscriptions": "Assinaturas",
	"ar_chart_jan_abreviacao": "Jan",
	"ar_chart_fev_abreviacao": "Fev",
	"ar_chart_mar_abreviacao": "Mar",
	"ar_chart_abr_abreviacao": "Abr",
	"ar_chart_mai_abreviacao": "Mai",
	"ar_chart_jun_abreviacao": "Jun",
	"ar_chart_jul_abreviacao": "Jul",
	"ar_chart_ago_abreviacao": "Ago",
	"ar_chart_set_abreviacao": "Set",
	"ar_chart_out_abreviacao": "Out",
	"ar_chart_nov_abreviacao": "Nov",
	"ar_chart_dez_abreviacao": "Dez",
	"ar_total": "Total",
	"ar_subscriber": "Assinante",
	"ar_resume": "Resumo",
	"ar_prediction": "Previsão próximos dias",
	"ar_30_days": "30 dias",
	"ar_12_months": "12 meses",
	"ar_empty": "Nenhuma informação disponível para ser exibida.",
	"ar_invalid_period": "Data inválida. O período minímo é de {days} dias.",
	"ar_all": "Tudo",

	"resource_title": "Recursos",

	"overview_online_acc": "Conta Live",
	"overview_testing_acc": "Conta Teste",
	"overview_closed_acc": "Conta Fechada",
	"overview_testing_closed_acc": "Conta Teste Fechada",
	"overview_low_touch": "Low touch",
	"overview_middle_touch": "Middle touch",
	"overview_high_touch": "High touch",
	"overview_top_tier": "Top tier",
	"overview_pb_eleva": "PB Eleva",
	"overview_none_touch": "Outras",
	"search_tipo_order": "Ordem",
	"search_tipo_internal_number": "Número interno",
	"search_tipo_email": "E-mail",
	"search_tipo_taxid": "CPF/CNPJ",
	"submit": "Enviar",
	"send_pbf": "Enviar para PBF",
	"save": "Salvar",
	"clone": "Clonar",
	"execute": "Executar",
	"update": "Atualizar",
	"close": "Fechar",
	"remove": "Remover",
	"send": "Enviar",
	"cancel": "Cancelar",
	"pause": "Pausar",
	"activate": "Ativar",

	"pl_title": "Link de Pagamento",
	"pl_search_title": "Buscar Link de Pagamento",
	"pl_order": "Ordem",
	"pl_product_name": "Nome do produto",
	"pl_customer_name": "Nome",
	"pl_customer_taxid": "CPF/CNPJ",
	"pl_customer_email": "E-mail",
	"pl_customer_phone": "Telefone",
	"pl_address_street": "Endereço",
	"pl_address_number": "Número",
	"pl_address_number_complement": "Complemento",
	"pl_address_neighborhood": "Bairro",
	"pl_address_zip": "CEP",
	"pl_address_city": "Cidade",
	"pl_address_state": "Estado",
	"pl_amount": "Valor",
	"pl_amount_brl": "Valor (R$)",
	"pl_fx_amount": "Valor ({0})",
	"pl_favorecido": "Lista de clientes",
	"pl_payment_option": "Métodos de pagamento",
	"pl_url_retorno": "URL de retorno",
	"pl_url_parametro": "Parâmetros extras",
	"pl_btn_create": "Criar",
	"pl_copy": "Copiar",
	"pl_click_to_copy_link": "Clique para copiar o link",
	"pl_generate_new_payment_link": "Gerar novo link de pagamento",
	"pl_copy_to_your_clipboard": "Copiado para sua área de transferência!!",

	"pl_invalid_field_order": "Campo Inválido (Ordem).",
	"pl_invalid_field_product_name": "Campo Inválido (Nome do produto).",
	"pl_invalid_field_customer_name": "Campo Inválido (Nome do cliente).",
	"pl_invalid_field_customer_taxid": "Campo Inválido (CPF/CNPJ do cliente).",
	"pl_invalid_field_customer_email": "Campo Inválido (E-mail do cliente).",
	"pl_invalid_field_customer_phone": "Campo Inválido (Telefone do cliente).",
	"pl_invalid_field_address_street": "Campo Inválido (Endereço).",
	"pl_invalid_field_address_zip": "Campo Inválido (CEP).",
	"pl_invalid_field_address_city": "Campo Inválido (Cidade).",
	"pl_invalid_field_address_state": "Campo Inválido (Estado).",
	"pl_invalid_field_amount_brl": "Campo Inválido (Valor R$).",
	"pl_invalid_field_fx_amount": "Campo Inválido (Valor {0}).",
	"pl_invalid_field_discount_brl": "Campo Inválido (Desconto R$).",
	"pl_invalid_field_payment_option": "Campo Inválido (Métodos de pagamento).",
	"pl_invalid_field_return_url": "Campo Inválido (URL de retorno).",
	"pl_invalid_field_payment_link_valid": "Campo Inválido (Link de Pagamento válido por).",
	"pl_invalid_field_boleto_expiration": "Campo Inválido (Validade do Boleto).",
	"pl_invalid_field_pec_expiration": "Campo Inválido (Validade do PEC).",
	"pl_invalid_field_pix_expiration": "Campo Inválido (Validade do PIX).",
	"pl_failed_to_create": "Falha ao criar link de pagamento.",
	"pl_please_provide_a_valid_email": "Por favor, verifique o e-mail informado",
	"pl_taxid_invalid": "Por favor, verifique o CPF/CNPJ informado",
	"pl_duplicated_order": "Falha ao criar link de pagamento - Ordem duplicada",

	"pl_label_credit_card_auth": "Ação do cartão de crédito",
	"pl_label_credit_card_auth_0": "Autorizar e debitar",
	"pl_label_credit_card_auth_1": "Somente autorizar",
	"pl_label_soft_descriptor": "Soft descriptor",
	"pl_label_max_installments": "Parcelamento",
	"pl_label_cc_installments": "Fixar parcela",
	"pl_product_list": "Lista de produtos",
	"pl_btn_select_products": "Catálogo de Produtos",
	"pl_label_selected_product": " produto selecionado.",
	"pl_label_selected_products": " produtos selecionados.",
	"pl_label_no_product_selected": "Nenhum produto selecionado.",
	"pl_label_remove_product": "Você quer excluir o produto: #product_name#?",
	"pl_label_quantity": "Quantidade",
	"pl_label_discount": "Desconto",
	"pl_label_details": "Detalhes",
	"pl_label_customer_product_data": "Dados do cliente e produto",
	"pl_label_customer_address": "Endereço do cliente",
	"pl_label_advanced_settings": "Configurações avançadas",
	"pl_label_add_products_from_catalog": "Adicionar produtos do catálogo",
	"pl_label_request_address_data_customer": "Solicitar ao cliente que informe seu endereço",
	"pl_label_always_request_address_data_customer": "Sempre solicitar dados de endereço ao cliente",
	"pl_label_type_return_checkout": "Escolha o formato do retorno",
	"pl_info_override_max_installments": "Sobrescreve a configuração do número máximo de parcelas",
	"pl_info_product_name": "Preencha o nome do produto ou crie uma lista usando o Catálogo abaixo",
	"pl_info_discount_range": "Quando o valor estiver fora da faixa de desconto, será aplicado o desconto definido no Desconto por pagamento.",
	"pl_choose": "Selecionar",
	"pl_up_to": "Até",
	"pl_interest_free": "sem juros",
	"pl_with_interest": "com juros",
	"pl_currency_x_brl": "x R$",
	"pl_hide_cc": "Esconder opção de cartão de crédito:",

	"favorecido_title": "Lista de Clientes",
	"favorecido_product_name": "Nome do produto",
	"favorecido_customer_name": "Nome do cliente",
	"favorecido_customer_taxid": "CPF/CNPJ do cliente",
	"favorecido_customer_email": "E-mail do cliente",
	"favorecido_customer_phone": "Telefone do cliente",
	"favorecido_address_street": "Endereço",
	"favorecido_address_number": "Número",
	"favorecido_address_complement": "Complemento",
	"favorecido_address_neighborhood": "Bairro",
	"favorecido_address_zip": "CEP",
	"favorecido_address_city": "Cidade",
	"favorecido_address_state": "Estado",

	"favorecido_msg_added": "Cliente adicionado com sucesso.",
	"favorecido_msg_updated": "Cliente atualizado com sucesso.",
	"favorecido_msg_deleted": "Cliente removido com sucesso.",
	"favorecido_msg_valid_taxid": "Campo inválido (CPF/CNPJ).",
	"favorecido_msg_fields_required": "Campo obrigatório não preenchido.",

	"fee_report": "Relatório de Taxas",

	"consolidate_stats": "Atualizar",
	"consolidated_by_month": "Consolidado por Mês",
	"cons_rep_total_pending_amt": "Valor Total Pendente",
	"cons_rep_total_pending_bluestream": "Total Pendente da Remessa para a Bluestream",
	"cons_rep_total_pending_pagsmart": "Total Pendente da Remessa para a PagSmart",
	"cons_rep_date": "Data",
	"cons_rep_amount_paid": "Valor Pago",
	"cons_rep_fees_pb": "Taxas (PB)",
	"cons_rep_fees_bs": "Taxas (BS)",
	"cons_rep_fees_total": "Taxas (total)",
	"cons_rep_refund": "Estorno",
	"cons_rep_chargeback": "Chargeback",
	"cons_rep_net_amt_est": "Valor Líquido EUR/USD",
	"cons_rep_net_amt": "Valor Líquido",

	"fsp_title": "Estatísticas Totais de Pagamento",

	"fs_title": "Estatísticas Totais",
	"fs_credit_card": "Cartão de Crédito",
	"fs_payment_method": "Método de Pagamento",
	"fs_qty_total": "Qtd. Total",
	"fs_qty_successful": "Qtd. com Sucesso",
	"fs_perc_success": "Taxa de Sucesso",
	"fs_revenue": "Faturamento",
	"fs_tran_revenue": "Faturamento",
	"fs_refund": "Estorno",
	"fs_chargeback": "Chargeback",
	"fs_fee": "Taxa",
	"fs_our_cost": "Nosso Custo",
	"fs_gross_profit": "Lucro Bruto",
	"fs_spread": "Spread Rev.",
	"fs_brand": "Bandeira",
	"fs_parcela": "Parcela",
	"fs_min_remittance": "Remessa Mín.",
	"fs_total_pending_amt": "Valor Total Pendente :  R$",
	"fs_alert_pending_amt": "Ocultar Alerta de Valor Total Pendente",
	"fs_month" : "Mês",
	"fs_months": "Meses",
	"fs_choose": "Você precisa escolher uma opção!",

	"fs_date": "Data",
	"fs_amount_paid": "Valor Pago",
	"fs_fees": "Taxas",
	"fs_refunds": "Estornos",
	"fs_chargebacks": "Chargebacks",
	"fs_remittance": "Remessa",
	"fs_net_amt": "Valor Líquido",
	"fs_reserve": "Reserva",
	"fs_processed": "Processado",
	"fs_tipo": "Tipo",
	"fs_select_month": "Selecione o mês",

	"fs_filter_activated": "Ativado",
	"fs_filter_deactivated": "Desativado",

	"forecast_title": "Previsão",

	"fee_nupay_cc" : "Taxa NuPay - Cartão de Crédito (à vista)",
	"fee_nupay_ccp" : "Taxa NuPay - Cartão de Crédito (Parcelado 2 até 6)",
	"fee_nupay_ccp24" : "Taxa NuPay - Cartão de Crédito (Parcelado 7 até 24)",
	"fee_nupay_dc" : "Taxa NuPay - Cartão de Débito",

	"fee_nupay_cc_report" : "NuPay CC (à vista)",
	"fee_nupay_ccp_report" : "NuPay CC (de 2 to 6)",
	"fee_nupay_ccp24_report" : "NuPay CC (de 7 to 24)",
	"fee_nupay_dc_report" : "NuPay DC",

	"fc_title": "Comparativo Mensal",
	"fc_merchant": "Estabelecimento",
	"fc_revenue_forecast": "Mês atual (estimativa)",
	"fc_revenue_mes_01": "Último mês",
	"fc_revenue_mes_02": "Penúltimo mês",
	"fc_percentual_mes_01": "Variação",
	"fc_percentual_mes_02": "Variação",
	"fc_last_update": "Última Atualização",
	"fc_user": "Usuário",

	"statstime_title": "Relatório de Alertas",
	"st_paymethod": "Método de Pagamento",
	"st_date": "Data",
	"st_export_csv": "Exportar para CSV",
	"st_status": "Status",
	"st_24hour": "+24 horas sem transações com sucesso",
	"st_72hour": "+72 horas sem transações com sucesso",

	"rr_title": "Relatório de Reservas",

	"status_live": "Live",
	"status_test": "Teste",
	"status_closed": "Fechada",
	"status_only_total": "Apenas Totais",
	"status_all": "Todos",
	"status_all_pagstream": "Todos",

	"new_title": "Avisos",
	"new_pick_month": "Escolha um mês",
	"new_data": "Data",
	"new_tipo": "Tipo",
	"new_titulo": "Título",
	"new_acoes": "Ações",
	"new_ativo": "Ativo",
	"new_inativo": "Inativo",
	"new_conteudo": "Conteúdo",
	"new_holiday": "Lista Mensal de Feriados",
	"new_more": "mais",
	"new_information": "Informações",
	"new_alert": "Alerta",
	"new_warning": "Aviso",
	"new_message": "Mensagem",

	"hol_data": "Data",
	"hol_ativo": "Ativo",
	"hol_inativo": "Inativo",
	"hol_descricao": "Descrição",
	"hol_acoes": "Ações",
	"hol_title": "Feriados",
	"hol_bank": "Feriado Bancário",

	"stdia_title": "Total de Hoje",
	"stdia_merchant": "Estabelecimento",
	"stdia_qty_total": "Qtd. Total",
	"stdia_qty_successful": "Qtd. com Sucesso",
	"stdia_perc_success": "Taxa de Sucesso",
	"stdia_revenue": "Faturamento",
	"stdia_refund": "Estorno",
	"stdia_chargeback": "Chargeback",
	"stdia_fee": "Taxa",
	"stdia_our_cost": "Nosso Custo",
	"stdia_gross_profit": "Lucro Bruto",
	"stdia_spread": "Spread",

	"nf_title": "Nota Fiscal",
	"nf_title_markup": "Nota Fiscal Markup",
	"modal_gerar_nota": "Gerar Nota Fiscal",

	"pagshield_title": "PagShield",
	"pagshield_activate": "Ativar PagShield:",
	"pagshield_by_activate": "Ativando o sistema de prevenção de fraude PagShield, você declara que sua empresa e você entendem e concordam com os seguintes termos e condições.",
	"pagshield_terms": "Termos e condições:",
	"pagshield_msg1": "O PagShield usa tecnologia de autoaprendizado para analisar o comportamento do comprador, auxiliando a identificar potenciais fraudes com cartão de crédito. Para configurar este serviço, os seguintes passos precisam ser tomados: aceitar os termos e condições do serviço do PagShield, configurar o serviço, adicionar parâmetros à sua integração atual e adicionar um snippet Javascript em todas as suas páginas.",
	"pagshield_msg2": "Uma vez ativado e configurado, todas as tentativas de compra com cartão de crédito, com um valor igual ou superior ao definido abaixo, serão analisadas e uma pontuação de risco enviada via API.",
	"pagshield_msg3": "A PagBrasil cobra uma taxa de R$ ",
	"pagshield_msg4": "por transação analisada. Ativar e configurar não possui custo e você pode requisitar a desativação do serviço a qualquer momento.",
	"pagshield_msg5": "O serviço estará disponível imediatamente após a ativação e configuração.",
	"pagshield_please_email": "Por favor, envie e-mail para",
	"pagshield_msg6": "em caso de dúvidas.",
	"pagshield_msg7": "Marque para confirmar que você leu e aceita os termos de ativação do PagShield.",
	"pagshield_msg8": "ID do serviço de antifraude:",
	"pagshield_msg9": "Para mais informações em como alterar o seu ID, por favor envie e-mail para",
	"pagshield_payment_amount": "Valor mínimo para análise do PagShield",
	"pagshield_msg10": "Processar transações com a prevenção de fraude do PagShield apenas quando o valor do pagamento >= R$",
	"pagshield_msg11": "Mova o controle deslizante abaixo para ajustar a pontuação:",
	"pagshield_recomendation": "Recomendação:",
	"pagshield_msg12": "Regra: PONTUAÇÃO >= 0 e PONTUAÇÃO <=",
	"pagshield_msg13": "Processar ordem imediatamente",
	"pagshield_msg14": "Regra: PONTUAÇÃO > ",
	"pagshield_msg15": "e PONTUAÇÃO <",
	"pagshield_msg16": "Pré-autorizar para revisão manual",
	"pagshield_msg17": "A ação de pré-autorização permite que estabelecimentos reservem um valor no cartão de crédito do cliente, para que checagens antifraude adicionais sejam feitas antes da captura do débito. A revisão manual precisa ser feita pelo estabelecimento. Transações que passem pela revisão manual podem ser capturadas via API ou clicando em 'Capturar' após carregar a ordem na guia 'Buscar Ordem'. As transações precisam ser capturadas em até 14 dias, quando a pré-autorização expira.",
	"pagshield_msg18": "e PONTUAÇÃO <= 100",
	"pagshield_decline": "Rejeitar",
	"pagshield_msg19": "Nunca processar imediatamente, apenas pré-autorizar para revisão manual sempre que este valor mínimo for atingido:",
	"pagshield_msg20": "A ação de pré-autorização permite que estabelecimentos reservem um valor no cartão de crédito do cliente, para que checagens antifraude adicionais sejam feitas antes da captura do débito. A revisão manual precisa ser feita pelo estabelecimento. Transações que passem pela revisão manual podem ser capturadas via API ou clicando em 'Capturar' após carregar a ordem na guia 'Buscar Ordem'. As transações precisam ser capturadas em até 14 dias, quando a pré-autorização expira.",
	"pagshield_msg21": "IMPORTANTE: Ordens com uma pontuação de fraude vermelha continuarão sendo rejeitadas.",
	"pagshield_msg22": "Caso ocorra um erro durante a obtenção da pontuação, siga as ações abaixo:",
	"pagshield_msg23": "Processar a ordem imediatamente",
	"pagshield_msg24": "Pré-autorizar para revisão manual",
	"pagshield_msg25": "A ação de pré-autorização permite que estabelecimentos reservem um valor no cartão de crédito do cliente, para que checagens antifraude adicionais sejam feitas antes da captura do débito. A revisão manual precisa ser feita pelo estabelecimento. Transações que passem pela revisão manual podem ser capturadas via API ou clicando em 'Capturar' após carregar a ordem na guia 'Buscar Ordem'. As transações precisam ser capturadas em até 14 dias, quando a pré-autorização expira.",
	"pagshield_msg26": "Enviar um e-mail de notificação quando uma revisão manual for necessária:",
	"pagshield_msg27": "Regra: PONTUAÇÃO >= ",
	"pagshield_email": "E-mail:",
	"pagshield_msg28": "E-mail da pessoa responsável por realizar uma checagem antifraude adicional para decidir se a transação será aprovada (capturada) ou não. Por favor, separe diferentes e-mails por vírgula.",
	"pagshield_msg29": "O PagShield é a solução inteligente da PagBrasil para prevenção de fraude. Desenvolvido especialmente para o Brasil e baseado em uma tecnologia única com inteligência auto-didata de análise do comportamento do comprador, o PagShield combate fraudes em tempo real a um baixo custo. Isto vai lhe ajudar a identificar transações fraudulentas automaticamente e reduzir falsos positivos.",
	"pagshield_msg30": "O custo do PagShield é de apenas R$ ",
	"pagshield_msg31": "por transação de cartão de crédito analisada. Você pode excluir transações de pequeno valor da análise de fraude, evitando custos adicionais.",
	"pagshield_msg32": "Como começar?",
	"pagshield_msg33": "1. Faça o download do nosso 'Merchant Guide PagShield Fraud Prevention' no menu 'Recursos'.",
	"pagshield_msg34": "2. Envie um e-mail para",
	"pagshield_msg35": "para solicitar a ativação do serviço antifraude PagShield.",
	"pagshield_msg36": "3. Uma vez ativado, você pode configurar o PagShield facilmente com apenas alguns cliques.",
	"pagshield_msg37": "Atenção: Ordens geradas por link de pagamento podem ter risco de fraude. Ao desativar o PagShield desses pedidos, você deve estar ciente do potencial risco de chargeback.",
	"pagshield_msg38": "Desativar PagShield para links de pagamento :",
	"pagshield_sell_safely": "Venda com segurança!",
	"pagshield_alert_msg": "Ativação do PagShield enviada com sucesso.",
	"pagshield_approve": "Aprovar",
	"pagshield_review": "Revisar",
	"pagshield_decline": "Negar",
	"pagshield_action": "Ação",
	"pagshield_checkshdamt": "Configurar um valor diferente de R$ 0,00 neste campo significa que todos os pedidos abaixo desse valor não terão qualquer tipo de análise de risco, aumentando o risco de transações fraudulentas serem aprovadas.",
	"pagshield_checkshdscr1": "Todos os pedidos a partir da pontuação 30 são de risco e, têm maiores chances de se tornarem chargebacks. Recomendamos muito cuidado com a elevação da faixa verde para aprovar automaticamente estes pedidos.",
	"pagshield_slider_history": "Histórico de Alteração",
	"pagshield_previus_score": "Score Anterior",

	"payee_title": "Favorecidos",
	"payee_id": "Id",
	"payee_cpfcnpj": "CPF/CNPJ",
	"payee_merchant": "Filial",
	"payee_name": "Nome",
	"payee_email": "E-mail",
	"payee_phone": "Telefone",
	"payee_address": "Endereço",
	"payee_street": "Endereço",
	"payee_zip": "CEP",
	"payee_city": "Cidade",
	"payee_state": "Estado",
	"payee_bank_detail": "Dados Bancários",
	"payee_bank": "Banco",
	"payee_branch": "Agência",
	"payee_account": "Conta",
	"payee_account_type": "Tipo da conta",
	"payee_document_link": "Link do documento",
	"payee_description": "Descrição",
	"payee_status": "Status",
	"payee_acoes": "Ações",
	"payee_status_pending": "Pendente",
	"payee_status_approved": "Aprovado",
	"payee_status_reject": "Rejeitado",
	"payee_justification": "Justificativa",
	"payee_document": "Documento",
	"payee_checking": "Conta Corrente",
	"payee_savings": "Conta Poupança",
	"payee_generate_payout": "Enviar Payout",
	"payee_validate_payee": "Validar Favorecido",
	"payee_amount": "Valor",
	"payee_btn_validate": "Validar",
	"payee_btn_edit": "Editar",
	"payee_btn_delete": "Excluir",
	"payee_btn_execute": "Enviar Payout",
	"payee_status_atualizado": "Status atualizado com sucesso.",
	"payee_checking": "Conta Corrente",
	"payee_saving": "Conta Poupança",

	"payout_settings_title": "Configurações de Payout",
	"payout_settings_ativo": "Payout",
	"payout_settings_tipo_transacao": "Tipo de transação",
	"payout_settings_ambas": "Ambas",
	"payout_settings_apenas_payee": "Apenas favorecidos",
	"payout_settings_apenas_merchant": "Apenas estabelecimentos",
	"payout_settings_saldo": "Saldo total",
	"payout_settings_saldo_minimo": "Reserva total",
	"payout_settings_saldo_minimo_tooltip": "Este valor corresponde ao % de reserva aplicada sobre o total transacionado na conta de Coleta de acordo com as regras do contrato.",
	"payout_settings_saldo_percentual": "Percentual de reserva",
	"payout_settings_saldo_liquido": "Saldo líquido disponível",
	"payout_settings_saldo_liquido_tooltip": "Saldo disponível para payout. Saldo total - Reserva total.",
	"payout_settings_aprovacao_payee": "Revisar cadastro de recebedor",
	"payout_settings_formato": "Tipo de resposta",
	"payout_settings_alert_threshold": "Alerta de valor de payout",
	"payout_settings_dia_adiamento": "Adiamento do payout",

	"payout_title": "Payout",
	"payout_id": "Id",
	"payout_detail": "Detalhes",
	"payout_valor": "Valor",
	"payout_data_cadastro": "Data",
	"payout_data_pagamento": "Data do Payout",
	"payout_type": "Tipo",
	"payout_status": "Status",
	"payout_acoes": "Ações",
	"payout_status_pending": "Pendente",
	"payout_status_approved": "Completado",
	"payout_status_fail": "Falha",
	"payout_status_schedule": "Agendado",
	"payout_payee": "Favorecido",
	"payout_merchant": "Estabelecimento",
	"payout_current_limit": "Limite atual para pagamentos",
	"payout_select_merchant": "Por favor, selecione o recebedor.",
	"payout_savings": "Conta Poupança",
	"payout_checking": "Conta Corrente",
	"payout_name": "Nome",
	"payout_taxid": "CPF/CNPJ",
	"payout_description": "Descrição",
	"payout_data_processamento": "Data de processamento",
	"payout_between_accounts": "Entre contas da PagBrasil",

	"payout_fee_info1": "Payout para favorecido",
	"payout_fee_info2": "Payout para conta de estabelecimento",
	"payout_fee_info3": "Aprovação ou rejeição de favorecido",

	"payout_movement_title": "Pay-in/Payout",
	"payout_movement_id": "Id",
	"payout_movement_data_inclusao": "Data",
	"payout_movement_amount": "Valor",
	"payout_movement_description": "Descrição",
	"payout_movement_merchant_origin": "Merchant de origem",
	"payout_movement_ordem_origin": "Ordem de origem",
	"payout_movement_payout_id": "Payout Id",
	"payout_movement_order": "Ordem",

	"pg_title": "Grupo de Permissões",
	"pg_descricao": "Descrição",
	"pg_tipo": "Tipo",
	"pg_acoes": "Ações",

	"user_title": "Usuário",
	"user_merchant_number": "Estabelecimento",
	"user_username": "Nome de Usuário",
	"user_rep_format": "Formato de Data e Decimal",
	"user_tipo": "Tipo",
	"user_idgrupo_permissao": "Grupo de Permissões",
	"user_descricao": "Descrição",
	"user_acoes": "Ação",
	"user_password": "Senha",
	"user_tentativa": "Tentativas de Login",
	"user_email": "E-mail",
	"user_questao": "Questão",
	"user_resposta": "Resposta",
	"user_viewonly": "Apenas Visualização",
	"user_restrict": "Restrito",
	"user_fullaccess": "Acesso Total",
	"user_superuser": "Super Usuário",
	"user_login_mes": "Login Mês",
	"user_status": "Situação",
	"user_status_active": "Ativo",
	"user_status_blocked": "Bloqueado",
	"user_status_permanently_blocked": "Permanentemente Bloqueado",
	"user_inclusao_sucesso": "Inclusão realizada com sucesso.",
	"user_alteracao_sucesso": "Alteração realizada com sucesso.",
	"user_block_user": "Bloquear Usuário",
	"user_reset_password": "Resetar Senha",
	"user_unblock_user": "Desbloquear Usuário",
	"user_reset_double_factor": "Resetar duplo fator de autenticação",
	"user_minimum_fields": "Informe o Nome de Usuário, E-mail, Tipo e Grupo de Permissão",
	"user_password_reset": "Senha resetada: ",
	"user_blocked": "Usuário bloqueado",
	"user_unblocked": "Usuário desbloqueado",
	"user_clean_two_factor": "Deseja limpar o token de segurança do duplo fator de autenticação?",
	"user_clean_two_factor_success": "Duplo fator de autenticação limpo com sucesso.",
	"user_clone_success": "Clone realizado com sucesso.",

	"pixconfig_id": "Id",
	"pixconfig_banco": "Banco",
	"pixconfig_prioridade": "Prioridade",
	"pixconfig_ativo": "Ativo",
	"pixconfig_info_pagador": "Informações do Pagador",
	"pixconfig_fluxo_inativo": "Temporariamente desativado",

	"perm_id": "Id",
	"perm_idgrupo_permissao": "Grupo de Permissões",
	"perm_sistema": "Sistema",
	"perm_acoes": "Ações",
	"perm_title": "Permissões",
	"perm_insert": "Inserção",
	"perm_update": "Atualização",
	"perm_delete": "Exclusão",
	"perm_select": "Seleção",

	"pc_title": "Permissão Campo",
	"pe_title": "Permissão Especial",
	"pm_title": "Permissões por Merchant",
	"pe_id": "Id",
	"pe_idgrupo_permissao": "Grupo de Permissões",
	"pe_merchant": "Merchant",
	"pe_operacao": "Operação",
	"pe_permitido": "Permitido",
	"pe_acoes": "Ações",
	"pe_search_on": "BuscarOrdem: Buscar em Gateway",
	"pe_update_via": "BuscarOrdem: Atualizar na Cielo/Stone",
	"pe_revert_refund": "BuscarOrdem: Reverter o Estorno",
	"pe_refund": "BuscarOrdem: Estorno",
	"pe_refund_by_bank": "BuscarOrdem: Estorno por Transferência Bancária",
	"pe_chargeback": "BuscarOrdem: Chargeback",
	"pe_show_return_url": "BuscarOrdem: Exibir 'URL de Retorno'",
	"pe_show_cv_tid": "BuscarOrdem: Exibir 'CV' ou 'TID'",
	"pe_show_intern_info": "BuscarOrdem: Exibir 'Informações internas'",
	"pe_do_refund_closed": "BuscarOrdem: Realizar estornos em contas fechadas",
	"pe_show_reserve": "Reserva: Exibir 'Reserva'",
	"pe_do_reserve": "Conciliação: Botão 'Reserva'",
	"pe_do_processed": "Conciliação: Botão 'Processado'",
	"pe_reset_password": "Usuário: Resetar Senha",
	"pe_lock_user": "Usuário: Bloquear Usuário",
	"pe_unlock_user": "Usuário: Desbloquear Usuário",
	"pe_status_boleto": "BuscarOrdem: Status do Boleto",
	"pe_admin_order": "BuscarOrdem: Administrar ordem",
	"pe_revisao_account": "Conta: Revisão",
	"pe_fullstats_refresh": "Stats: Atualizar FullStats",
	"pe_fullstatspayment_refresh": "Stats: Atualizar FullStatsPayment",
	"pe_payee_approve": "Pagamentos: Aprovação de Fornecedores",
	"pe_payment_discount": "Produtos: Payment Link - Desconto por Pagamento",
	"pe_products_enabledpayments": "Produtos: Métodos de Pagamento",
	"pe_issuingbank_pix": "BuscaOrdem: Banco Emissor = Pix",
	"pe_sistema": "Sistema",
	"pe_campo": "Campo",
	"pe_insert": "Inserção",
	"pe_select": "Visualização",
	"pe_destaque": "Destaque",
	"pe_toggle_insert": "Alternar Inserção",
	"pe_toggle_select": "Alternar Visualização",
	"pe_toggle_highlight": "Alternar Destaque",
	"pe_pod_admin": "POD Report: Admin",
	"pe_add_new_order": "BuscarOrdem: Adicionar Nova Ordem",
	"pe_cancel_order": "BuscarOrdem: Cancelar Ordem",
	"pe_desativar_pagshield": "PagShield: Desativar",
	"pe_extend_expiration": "BuscarOrdem: Estender data de vencimento",
	"pe_anticipation_approve": "Aprovar Antecipação",
	"pe_anticipation_reject": "Rejeitar Antecipação",
	"pe_new_order_model_option_fee": "BuscarOrdem: Modelo de ordem opção de tarifa",
	"pe_new_order_model_option_payment": "BuscarOrdem: Modelo de ordem opção de pagamento",
	"pe_block_capture": "BuscarOrdem: Bloqueia captura de ordem",
	"pe_revenue_group_list": "Conta: Lista de grupo de receita",
	"pe_pagstream_reactivate_subscription": "Pagstream: Reativar assinatura",

	"refr_title": "Relatório de Estornos/Chargebacks",
	"refr_refunds": "Estornos",
	"refr_chargebacks": "Chargebacks",
	"refr_payment_method": "Método de Pagamento",
	"refr_qty_total": "Qtd. Total",
	"refr_vlr_original": "Valor da Ordem",
	"refr_refund": "Estorno",
	"refr_fee": "Taxa",

	"payment_pec": "PEC Flash",
	"payment_boleto": "Boleto Bancário",
	"payment_boleto_flash": "Boleto Flash",
	"payment_credit_card": "Cartão de Crédito",
	"payment_debit_card": "Cartão de Débito",
	"payment_debit_flash": "Débito Flash",
	"payment_banco_brasil": "Banco do Brasil",
	"payment_pb_debit_credit": "Crédito/Débito da PagBrasil",
	"payment_bradesco": "Bradesco",
	"payment_banrisul": "Banrisul",
	"payment_obt": "Transferência/Depósito Bancário",
	"payment_itau": "Itaú",
	"payment_paypal": "PayPal",
	"payment_nupay": "NuPay",
	"payment_pix": "Pix",
	"payment_boleto_express_flash": "Boleto Express/Flash",
	"payment_nupay": "NuPay",

	"payment_remittance_date": "Data",
	"payment_remittance_fx_amount": "Valor em moeda estrangeira",

	"revenue_title": "Relatório de Faturamento",
	"revenue_boleto_fee": "Boleto Fee",
	"revenue_boleto_fix": "Boleto Fix",
	"revenue_boleto_min": "Boleto Min.",
	"revenue_flash_fee": "Boleto Flash Fee",
	"revenue_flash_fix": "Boleto Flash Fix",
	"revenue_cc_fee_a_vista": "CC Fee à vista",
	"revenue_cc_fee_2_6": "CC Fee de 2 a 6",
	"revenue_cc_fee_7_12": "CC Fee de 7 a 12",
	"revenue_cc_fix": "CC Fix",
	"revenue_dc_fee": "DC Fee",
	"revenue_dc_fix": "DC Fix",
	"revenue_pagbrasil_solution": "Solução PagBrasil",
	"revenue_pagbrasil_solution_gateway": "Solução Gateway",
	"revenue_pagbrasil_solution_intermediacao": "Solução Intermediação",
	"revenue_banricompras_fee": "Banricompras Fee",
	"revenue_banricompras_fix": "Banricompras Fix",
	"revenue_bradesco_fee": "Bradesco CE Fee",
	"revenue_bradesco_fix": "Bradesco CE Fix",
	"revenue_bb_fee": "BB Fee",
	"revenue_bb_fix": "BB Fix",
	"revenue_itau_fee": "Itaú Fee",
	"revenue_itau_fix": "Itaú Fix",
	"revenue_obt_fee": "Bank Transfer Fee",
	"revenue_obt_fix": "Bank Transfer Fix",
	"revenue_chargeback": "Chargeback",
	"revenue_refund_cartoes": "Refund Card",
	"revenue_refund_boleto": "Refund Boleto",
	"revenue_reserve_of": "Reserve of",
	"revenue_rate_cc": "Interest rate CC",
	"revenue_remittance_fee": "Remittance Fee",
	"revenue_remittance_minimum": "Minimum remittance",
	"revenue_pec_fee": "PEC Flash Fee",
	"revenue_pec_fix": "PEC Flash Fix",
	"revenue_pix_fee": "Pix Fee",
	"revenue_pix_fee_auto": "Pix Automático Fee",
	"revenue_pix_fix": "Pix Fix",
	"revenue_paypal": "PayPal",
	"revenue_average": "Média",
	"revenue_jan_mar": "Janeiro - Março",
	"revenue_abr_jun": "Abril - Junho",
	"revenue_jul_set": "Julho - Setembro",
	"revenue_out_dez": "Outubro - Dezembro",
	"revenue_fee": "Fee",
	"filtrar_troca_faixa": "Filtrar apenas trocas de faixas",
	"trocar_todas_faixa": "Trocar todas as faixas",
	"faixa_atual": "Faixa atual",
	"trocar_faixa": "Trocar faixa",
	"proxima_faixa": "Próxima faixa",

	"freq_test_account": "Conta Teste",
	"freq_maintence_account": "Conta em Manutenção",
	"freq_daily": "Diariamente",
	"freq_weekly": "Semanalmente",
	"freq_every_other_week": "Semanas alternadas",
	"freq_twice_month": "Duas vezes ao mês",
	"freq_monthly_15": "Mensalmente no 15º dia",
	"freq_closed_account": "Conta Fechada",
	"freq_closed_testing": "Conta Teste Fechada",
	"freq_no_settlement": "Sem fechamento",

	"login_title": "Login",
	"login_username": "Usuário",
	"login_username_ph": "Informe seu usuário",
	"login_password": "Senha",
	"login_password_ph": "Informe sua senha",
	"login_password_tooltip": "Sua senha deve conter ao menos 8 caracteres, 1 letra maiúscula, 1 minúscula, 1 número e 1 caractere não alfanumérico.",
	"login_gtoken_ph": "Token",
	"login_first_login": "Primeiro login?",
	"login_first_login_message": "Deixe em branco se for o seu primeiro login.",
	"login_validate_gtoken": "Validar Token",
	"login_new_password": "Nova Senha",
	"login_confirm_password": "Confirme a senha",
	"login_confirm_new_password": "Confirme a Nova Senha",
	"login_security_question": "Pergunta de Segurança",
	"login_answer": "Resposta",
	"login_forgot_password": "Esqueci minha senha",
	"login_unlock_account": "Desbloquear usuário",
	"login_msg_invalid_username": "Usuário Inválido.",
	"login_msg_check_your_email": "Por favor, verifique seu e-mail para instruções de como resetar sua senha ou desbloquear seu usuário.",
	"login_msg_password_same": "As senhas não são idênticas.",
	"login_msg_inform_pass": "Você precisa informar sua senha.",
	"login_msg_inform_new_pass": "Você precisa informar sua nova senha.",
	"login_msg_inform_question": "Você precisa informar pergunta de segurança.",
	"login_msg_inform_answer": "Você precisa informar sua resposta.",
	"login_msg_password_updated": "Sua senha foi atualizada.",
	"login_msg_space_trim": "Sua senha não deve possuir caracteres de espaço no início ou no fim.",
	"login_msg_space_trim_super": "Não use um caractere de espaço no início ou final do nome de usuário ou senha.",
	"login_remember_this_computer": "Não solicitar o token novamente neste dispositivo",
	"login_first_access": "Primeiro acesso",
	"login_create_new_password": "Criar nova senha",
	"login_back_to_login": "Voltar para o login",
	"login_forgot_your_password": "Esqueceu sua senha?",
	"login_save_token_on_this_device": "Salvar token neste dispositivo.",
	"login_code": "Informe o código",
	"login_two_factor_authentication": "Ative a autenticação em dois fatores (obrigatório)",
	"login_text_one_part_one_authentication": "Faça o download e instalação de um aplicativo de autenticação em seu telefone.",
	"login_text_one_part_two_authentication": "Nós recomendamos o ",
	"login_or": "ou",
	"login_microsoft_authenticator": "Microsoft Authenticator",
	"login_google_authenticator": "Google Authenticator",
	"login_duo_authenticator": "Duo",
	"login_text_two_authentication": "Abra o aplicativo escolhido e escaneie o QR code abaixo:",
	"login_validate_token": "Validar token",
	"login_your_password_must_contain": "Sua senha deve conter:",
	"login_8_characters": "8 caracteres",
	"login_lowercase": "Minúsculas",
	"login_capital_letters": "Maiúsculas",
	"login_special_character": "Caractere especial",
	"login_numbers": "Números",
	"login_recover_password": "Recuperar senha",
	"login_we_send_a_code_to": "Um código de recuperação foi enviado para o e-mail cadastrado nesta conta.",
	"login_check_inbox_or_spam": "Verifique sua caixa de entrada ou a pasta de spam.",
	"login_enter_code": "Informe o código:",
	"login_i_didnt_receive_the_email": "Não recebi o e-mail. ",
	"login_resend_code": "Reenviar código.",
	"login_msg_invalid_access_code": "Código de acesso inválido!",
	"login_create_password_and_access": "Criar senha e acessar",

	"login_msg_invalid_username_password": "Usuário/Senha inválido.",
	"login_msg_invalid_username_password_token": "Usuário/Senha/Token inválido.",
	"login_msg_all_fields_Are_required": "Todos os campos são obrigatórios!",
	"login_msg_same_password_confirmation": "Por favor, insira a mesma senha nos campos de nova senha e confirmação.",
	"login_msg_invalid_digits_password": "Sua senha deve conter ao menos 8 caracteres, 1 letra maiúscula, 1 minúscula, 1 número e 1 caractere não alfanumérico.",
	"login_msg_error_reset": "Ocorreu um erro durante a redefinição da senha.",
	"login_msg_username_locked": "Seu usuário foi bloqueado. Clique em 'Esqueceu sua senha'.",
	"login_no_access": "Acesso negado. Entre em contato com o administrador.",

	"message_title_success": "Sucesso",
	"message_title_warning": "Atenção",
	"message_title_error": "Erro",

	"pod_title": "Comprovante de Envio",
	"pod_order": "Ordem",
	"pod_report": "Relatório",
	"pod_payment_date": "Data de pagamento",
	"pod_tracking_code": "Código de rastreio",
	"pod_amount_paid": "Valor Pago",
	"pod_net_amount": "Valor Líquido",
	"pod_status": "Status",
	"pod_entrega": "Entrega",
	"pod_status_delivery": "Status entrega",
	"pod_pending": "Pendente",
	"pod_invalid": "Inválido",
	"pod_empty": "Ausente",
	"pod_not_found": "Não Encontrado",
	"pod_valid": "Válido",
	"pod_processing": "Em Processamento",
	"pod_import": "Importar",
	"pod_import_file": "Enviar arquivo",
	"pod_file_requirement": "Deve ser um .csv com duas colunas (ordem;código de rastreio), usando ';' como seprador.",
	"pod_example_file": "Arquivo Exemplo",
	"pod_ret_inclusao_pod1": " item incluído.",
	"pod_ret_inclusao_pod": " itens incluídos.",
	"pod_export_limit": "Limite de exportação excedido (10000 registros). Por favor, amplie o filtro.",
	"pod_data_submis": "Data de envio",
	"pod_acoes": "Ações",
	"pod_reprocessar": "Reprocessar",
	"pod_marcar_reprocessado_sub": "Esta opção altera todos os itens com o status 'Não Encontrado' para 'Pendente', permitindo que sejam reprocessados. Afeta apenas itens importados até 30 dias atrás.",
	"pod_reprocessado_sucesso": "Operação concluída com sucesso.",
	"pod_find_17track": "Buscar no 17track",
	"pod_import_17track": "Importar do 17track",
	"pod_17track_return": "Retorno da 17track",
	"pod_set_all_valid": "Marcar todos como válidos",
	"pod_set_valid": "Marcar como válido",
	"pod_set_invalid": "Marcar como inválido",
	"pod_total_not_valid": "Total não válido",
	"pod_qtde": "Qtd.",
	"pod_separator": "Separador",
	"pod_separator_track": "Separador do cód. de rastreio",
	"pod_select_columns": "Selecione as colunas correspondentes.",

	"pod_em_transito": "Em trânsito",
	"pod_alerta": "Alerta",
	"pod_entregue": "Entregue",
	"pod_indefinido": "Indefinido",

	"pod_question_valid": "Você quer marcar este item como válido?",
	"pod_question_valid_result": "Marcado como válido com sucesso.",
	"pod_question_invalid": "Você quer marcar este item como inválido?",
	"pod_question_invalid_result": "Marcado como inválido com sucesso.",
	"pod_question_valid_all": "Você quer marcar todos os registros selecionados como válidos?",

	"autorecset_title": "Regras",
	"autorecset_id": "Código",
	"autorecset_acoes": "Ações",
	"autorecset_product": "Produto",
	"autorecset_product_info": "Texto que o produto deve ser ou conter para que uma recorrência seja criada.",
	"autorecset_frequency": "Ciclo de cobrança",
	"autorecset_shipping_cycle": "Ciclo de entrega",
	"autorecset_status": "Status",
	"autorecset_limit": "Limite de recorrências",
	"autorecset_type": "Tipo",
	"autorecset_order": "Ordem",
	"autorecset_qtde_provisionamento_pre": "Visualizar",
	"autorecset_qtde_provisionamento_pos": "próximas cobranças",
	"autorecset_error_msg_empty": "Por favor, preencha os campos 'Produto', 'Tipo', 'Ciclo de cobrança' e 'Status'.",
	"autorecset_sku_error_msg_empty": "Por favor, preencha os campos 'SKU', 'Ciclo de cobrança' e 'Status'.",
	"autorecset_error_duplicated": "Esta regra não pode ser criada pois entra em conflito com outra regra, podendo gerar recorrências duplicadas. Por favor, altere o texto a ser buscado no nome do produto.",
	"autorecset_limit_warn": "Número máximo de recorrências (0 é ilimitado).",
	"autorecset_amount": "Valor (R$)",
	"autorecset_equal": "Igual",
	"autorecset_contains": "Contêm",
	"autorecset_to": "a",
	"autorecset_editnotallowed": "Não é possível editar uma regra que já possui recorrências geradas. Se necessário, crie uma nova regra.",
	"autorecset_amount_info": "Valor a ser cobrado nas recorrências (informe 0 para utilizar o valor do pedido inicial).",
	"autorecset_error_delete": "Essa regra não pode ser excluída pois está vinculada a uma recorrência.",
	"autorecset_sku": "SKU",
	"autorecset_search": "Buscar regras...",

	"autorec_config_error": "Erro: PagStream requer que a recorrência esteja ativada para esta conta.",

	"autorec_title": "Assinaturas",
	"autorec_charges": "Cobranças",
	"autorec_charge_errors": "Erros de cobrança",
	"autorec_events": "Eventos",
	"autorec_id": "ID",
	"autorec_acoes": "Ações",
	"autorec_order_number": "Assinatura",
	"autorec_order_number_rec": "Ordem",
	"autorec_empty": "-",
	"autorec_no_changes": "Não houveram modificações na assinatura.",
	"autorec_autorecset_id": "Regra",
	"autorec_product": "Produto",
	"autorec_payment_date": "Data de pagamento",
	"autorec_rule_id": "ID da Regra",
	"autorec_product_matched": "Regra",
	"autorec_payment_method": "Método",
	"autorec_frequency": "Ciclo de cobrança",
	"autorec_status": "Status",
	"autorec_status_original": "Status antigo",
	"autorec_status_novo": "Status novo",
	"autorec_order_number_status": "Status da ordem",
	"autorec_charge_status": "Status da cobrança",
	"autorec_subscription_status": "Status da assinatura",
	"autorec_qtde_gerado": "Número de recorrências",
	"autorec_data_prox_cobranca": "Próxima cobrança",
	"autorec_submission_date": "Data de Submissão",
	"autorec_data_cobranca": "Data de cobrança",
	"autorec_error_msg_empty_api": "Por favor, preencha todos os campos obrigatórios.",
	"autorec_error_empty_filter": "Por favor, filtre por próxima data de cobrança, e-mail ou CPF/CNPJ do cliente para gerar o relatório a ser exportado.",
	"autorec_error_invalid_filter": "Data inválida. O intervalo máximo de datas é de 120 dias.",
	"autorec_item_error_msg_empty": "Por favor, preencha os campos 'Produto' e 'Qtde.'.",
	"autorec_data_nascimento": "Data de nascimento",
	"autorec_data_cancelamento": "Data de cancelamento",
	"autorec_data_cancelamento_efetivo": "Data de cancelamento efetivo",
	"autorec_limit": "Limite",
	"autorec_default": "Padrão",
	"autorec_qtde_provisionamento_pre": "Visualizar",
	"autorec_qtde_provisionamento_pos": "próximas cobranças",
	"autorec_prev_saved": "Ordem tokenizada",
	"autorec_pix_rec_id": "ID da cobrança recorrente",
	"autorec_amount": "Valor (R$)",
	"autorec_amount_total": "Valor total (R$)",
	"autorec_amount_without": "Valor",
	"autorec_isentar": "Isentar essa cobrança",
	"autorec_pular": "Pular",
	"autorec_pular_confirm": "Você tem certeza que deseja pular essa cobrança?",
	"autorec_cancel_subscription": "Você tem certeza que deseja cancelar essa assinatura?",
	"autorec_pause_subscription": "Você tem certeza que deseja pausar essa assinatura?",
	"autorec_activate_subscription": "Você tem certeza que deseja ativar essa assinatura?",
	"autorec_reativar_confirm": "Esta cobrança já foi pulada, você tem certeza que deseja reativá-la?",
	"autorec_subscription_edit_data": "Editar dados da assinatura",
	"autorec_credit_card_edit_data": "Editar dados do cartão de crédito",
	"autorec_customer_edit_data": "Editar dados do cliente",
	"autorec_customer": "Cliente",
	"autorec_customer_filter": "Nome, CPF/CNPJ e e-mail",
	"autorec_customer_name": "Nome",
	"autorec_customer_taxid": "CPF/CNPJ",
	"autorec_customer_email": "E-mail",
	"autorec_customer_phone": "Telefone",
	"autorec_address_street": "Endereço",
	"autorec_address_zip": "CEP",
	"autorec_address_city": "Cidade",
	"autorec_address_state": "Estado",
	"autorec_cc_holder": "Nome no cartão",
	"autorec_cc_number": "Número",
	"autorec_cc_expiration": "Expiração",
	"autorec_cc_cvv": "CVV",
	"autorec_customer": "Cliente",
	"autorec_cc": "Cartão de Crédito",
	"autorec_pix_automatico": "Pix Automático",
	"autorec_payment_info": "Informações de pagamento",
	"autorec_subscription": "Assinatura",
	"autorec_num_recorrencia": "Num. recorrência",
	"autorec_desconto": "Desconto (%)",
	"autorec_limite_max": "*Porcentagem inválida.",
	"autorec_produto": "Produto",
	"autorec_quantidade": "Qtd.",
	"autorec_lista_item": "Lista de itens",
	"autorec_charge_tries": "Tentativas de cobrança",
	"autorec_dia_base": "Dia do mês da cobrança",
	"autorec_cycle_turnover_day": "Dia da mudança de ciclo",
	"autorec_atualizar_provisionamento": "Você estará atualizando todos os provisionamentos pendentes, tanto em questão de datas, como de itens e valores.",
	"autorec_param_url": "Parâmetros extras",
	"autorec_url_return": "URL de retorno",
	"autorec_url_return_info": "URL de redirecionamento quando o pagamento é feito utilizando o link enviado por e-mail ao cliente.",
	"autorec_shop_code": "Código da loja",
	"autorec_installments": "Parcelas",
	"autorec_search_products": "Buscar produtos...",
	"autorec_change_billing_cycle": "Alterar ciclo",
	"autorec_change_billing_cycle_confirm": "Você tem certeza que deseja alterar o ciclo desta assinatura?",
	"autorec_reactivate": "Reativar",
	"autorec_reactivate_subscription": "Reativar assinatura",
	"autorec_select_renewal_option": "Selecione a opção de reativação:",
	"autorec_renew_today": "Reativar assinatura e cobrar hoje.",
	"autorec_renew_original_date": "Reativar assinatura e cobrar na próxima data prevista.",
	"autorec_renew_today_selected": "Ao selecionar essa opção, as datas de cobranças futuras também serão atualizadas.",
	"autorec_renew_original_date_selected": "Ao selecionar essa opção, o sistema manterá as datas de cobrança conforme a criação da assinatura.",
	"autorec_renew_will_happen_today": "A cobrança acontecerá hoje.",
	"autorec_charge_provisioning": "Cobrar",
	"autorec_charge_provisioning_title": "Você deseja cobrar essa renovação?",
	"autorec_charge_provisioning_text": "",
	"autorec_extend": "Estender",
	"autorec_extend_provisioning": "Estender renovação",
	"autorec_extend_provisioning_dates": "A data de cancelamento deve ser menor que a data da próxima cobrança.",
	"autorec_extend_to": "Selecione a nova data de cancelamento:",
	"autorec_update_billing_date": "Editar data de cobrança",
	"autorec_update_billing_date_error": "A data da cobrança deve ser menor que a data de cancelamento.",
	"autorec_update_billing_date_to": "Selecione a nova data de cobrança:",
	"autorec_update_billing_date_overwrite_cycle_normal": "Alterar a data de cobrança pontualmente",
	"autorec_update_billing_date_overwrite_cycle_overwrite": "Alterar todas as datas de cobrança a partir desta renovação",
	"autorec_update_billing_date_overwrite_cycle_normal_info": "As datas de cobrança seguintes serão mantidas conforme o ciclo da assinatura.",
	"autorec_update_billing_date_overwrite_cycle_overwrite_info": "As datas de cobrança seguintes serão sobrescritas conforme a nova data de cobrança.",

	"autorec_more_future_charges": "Mais cobranças futuras",
	"autorec_more_past_charges": "Mais cobranças antigas",
	"autorec_next_provisioning": "Exibir próximas 3 cobranças",
	"autorec_consolidate_provisioning": "Consolidar provisionamentos",

	"autorec_status_active": "Ativo",
	"autorec_status_inactive_only": "Inativo",
	"autorec_status_new": "Aguardando primeiro pagamento",
	"autorec_status_rec": "Pagamento pendente",
	"autorec_status_inactive": "Inativo / Cancelado",
	"autorec_status_expired": "Expirado",
	"autorec_status_paused": "Pausado",
	"autorec_status_overdue": "Pagamento atrasado",
	"autorec_status_provisionado": "Pendente",
	"autorec_status_efetuado": "Processado",
	"autorec_status_completado": "Completado",
	"autorec_status_cancelado": "Cancelado",
	"autorec_status_pulado": "Pulado",
	"autorec_status_isento": "Isento",

	"autorecnot_title": "Notificações",
	"autorec_copy_email_to": "Copiar e-mail para",
	"autorec_copy_email_to_desc": "Receba uma cópia da notificação enviada ao seu cliente",
	"autorec_copy_email_notification": "Notificações para receber cópia",
	"autorec_activation": "Ativação",
	"autorec_reminder": "Lembrete de cobrança de cartão de crédito",
	"autorec_reminder_adicional": "Lembrete de cobrança de link de pagamento",
	"autorec_payment_link": "Link de pagamento",
	"autorec_cancellation": "Cancelamento",
	"autorec_confirmation": "Confirmação",
	"autorec_charge_payment": "Informação de pagamento",
	"autorec_charge_error": "Erro",
	"autorec_last_charge_date": "Data da última cobrança",
	"autorec_next_charge_date": "Data da próxima cobrança",
	"autorec_charge_attempts": "Tentativas",
	"autorec_charge_payment_method": "Método de pagamento",
	"autorec_allow_edit_item": "Edição na área do assinante",
	"autorec_user": "Usuário",
	"autorec_type": "Tipo",
	"autorec_date": "Data",
	"autorec_update": "Atualização",
	"autorec_provisioning_update": "Atualização de provisionamento",
	"autorec_tentativa": "Tentativa de cobrança",
	"autorec_cancelled_by": "Cancelado via",
	"autorec_subscriptionupdate": "Atualização de subscrição",
	"autorec_subscriptionpaused": "Pausa de subscrição",
	"autorec_information": "Informações",
	"autorec_is_unlimited": "(0 é ilimitado)",

	"autorecshipping_title": "Ciclos de Entrega",
	"autorecfreq_title": "Ciclos de Cobrança",
	"autorecfreq_id": "ID",
	"autorecfreq_frequency": "Código do ciclo",
	"autorecfreq_each": "A cada",
	"autorecfreq_units": "Unidades",
	"autorecfreq_interval": "Intervalo",
	"autorecfreq_quantity": "Quantidade",

	"autorecreports_title": "Relatórios",
	"autorecreports_select": "Selecione uma opção de relatório",
	"autorecreports_subscription": "Assinaturas",
	"autorecreports_subscription_products": "Assinaturas - Produtos",
	"autorecreports_current_overdues": "Assinaturas com pagamentos atrasados",
	"autorecreports_history_overdues": "Histórico de pagamentos atrasados",
	"autorecreports_preview": "Visualizar",
	"autorecreports_generate": "Gerar CSV",
	"autorecreports_filters": "Filtros",
	"autorecreports_start_date": "Data inicial",
	"autorecreports_end_date": "Data final",
	"autorecreports_subscription_number": "Assinatura",
	"autorecreports_subscription_status": "Status da assinatura",
	"autorecreports_status": "Status",
	"autorecreports_amount": "Valor",
	"autorecreports_data_insercao": "Data de inserção",
	"autorecreports_data_prox_cobranca": "Data da próxima cobrança",
	"autorecreports_frequency": "Frequência",
	"autorecreports_quantidade_gerado": "Contador de renovações",
	"autorecreports_skipped_count": "Contador de renovações puladas",
	"autorecreports_prev_saved": "Token da assinatura",
	"autorecreports_user_cancel": "Cancelado por",
	"autorecreports_data_cancelamento_efetivo": "Data do cancelamento",
	"autorecreports_motivo_cancelamento": "Motivo do cancelamento",
	"autorecreports_customer_email": "E-mail",
	"autorecreports_customer_taxid": "CPF/CNPJ",
	"autorecreports_customer_phone": "Telefone",
	"autorecreports_customer_name": "Nome",
	"autorecreports_customer_city": "Cidade",
	"autorecreports_customer_state": "Estado",
	"autorecreports_product_sku": "SKU",
	"autorecreports_product_name": "Produto",
	"autorecreports_product_amount": "Valor unidade",
	"autorecreports_product_quantity": "Quantidade",
	"autorecreports_product_discount": "Desconto",
	"autorecreports_overdues": "Quantidade de pagamentos atrasados",
	"autorecreports_min_recorrencia": "Primeira recorrência atrasada",
	"autorecreports_max_recorrencia": "Última recorrência atrasada",
	"autorecreports_report_preview": "Pré-visualização do relatório",
	"autorecreports_export_total": "Total a ser exportado",
	"autorecreports_rows": "registro(s)",
	"autorecreports_empty_rows": "Não há registros neste relatório",

	"autorecproduct_title": "Produtos",
	"autorecproduct_active_products": "Ativos",
	"autorecproduct_inactive_products": "Inativos",
	"autorecproduct_select": "Selecione um ou mais ciclos de cobrança",
	"autorecproduct_frequency": "Ciclo de cobrança",
	"autorecproduct_shipping_cycle": "Ciclo de entrega",
	"autorecproduct_frequencies": "ciclos de cobrança",
	"autorecproduct_settings": "Configurações do produto",
	"autorecproduct_disable_on_empty_freq": "O produto deve ter um ciclo de cobrança para estar disponível no PagStream. Ele será desabilitado se você não adicionar um ciclo.",
	"autorecproduct_filter": "Filtrar",
	"autorecproduct_filter_clear": "Limpar",
	"autorecproduct_filter_by": "Filtrar por",
	"autorecproduct_filter_product_name": "Nome do produto",
	"autorecproduct_filter_product_sku": "SKU do produto",
	"autorecproduct_filter_product_amount": "Valor do produto",
	"autorecproduct_filter_frequencies": "Ciclos de cobrança",
	"autorecproduct_unable_to_delete": "Não foi possível excluir",
	"autorecproduct_currently_in_use": "O ciclo de cobrança não pode ser excluído porque foi utilizado para a criação de assinaturas.",
	"autorecproduct_no_active_products": "Nenhum produto ativo",
	"autorecproduct_no_inactive_products": "Nenhum produto inativo",
	"autorecproduct_none": "Nenhum",

	"autorecfreq_title": "Ciclos de Cobrança",
	"autorecfreq_id": "ID",
	"autorecfreq_frequency": "Código do ciclo",
	"autorecfreq_quantidade": "Unidades",
	"autorecfreq_intervalo": "Intervalo",
	"autorecfreq_periodicity": "Periodicidade do ciclo",
	"autorecfreq_dia_lembrete": "Lembrete de cartão de crédito (dias)",
	"autorecfreq_dia_lembrete_adicional": "Lembrete de link de pagamento (dias)",
	"autorecfreq_days_to_cancel": "Dias após a cobrança até o cancelamento",
	"autorecfreq_days_to_cancel_desc": "Defina em quantos dias após a data de cobrança uma recorrência não paga é cancelada.",
	"autorecfreq_days_to_cancel_desc_start": "Recorrências não pagas são canceladas em",
	"autorecfreq_days_to_cancel_desc_end": "após a data de cobrança.",
	"autorecfreq_days_to_cancel_max": "Máximo de dias a serem configurados:",
	"autorecfreq_pix_rec_retry_number": "Número de retentativas de Pix Automático",
	"autorecfreq_pix_rec_retry_number_desc": "Define o número de retentativas para pagamentos via Pix Automático.",
	"autorecfreq_acoes": "Ações",
	"autorecfreq_remember_days": "Número de dias antes do vencimento para envio do lembrete de pagamento.",
	"autorecfreq_remember_days_aditional": "Número de dias que um lembrete de link de pagamento é enviado antes da data de cancelamento.",
	"autorecfreq_error_msg_empty": "Por favor, preencha todos os campos obrigatórios.",
	"autorecfreq_error_limit_day_5": "O período deve ser de no mínimo 5 dias.",
	"autorecfreq_error_delete": "Esse ciclo de cobrança não pode ser excluído pois está vinculado a uma recorrência.",

	"autorecprom_title": "Motor de Promoções",
	"autorecprom_id": "Código",
	"autorecprom_titulo": "Nome da regra",
	"autorecprom_status": "Status",
	"autorecprom_num_renovacao": "Limite de execuções",
	"autorecprom_acoes": "Ação",
	"autorecprom_error_msg_empty": "Por favor, preencha todos os campos obrigatórios.",
	"autorecprom_rules": "Regras",
	"autorecprom_discount": "Desconto",
	"autorecprom_rule_tipo": "Tipo",
	"autorecprom_valor_maior_que": "Valor maior que",
	"autorecprom_valor_maior_menos_frete": "Valor(menos frete) maior que",
	"autorecprom_contem_produto": "Contêm produto",
	"autorecprom_endereco_estado": "Estado no endereço",
	"autorecprom_renovacao_numero": "Limite de execuções",
	"autorecprom_periodo_criacao": "Data de criação da assinatura",
	"autorecprom_desconto_total": "Desconto total",
	"autorecprom_desconto_frete": "Desconto no frete",
	"autorecprom_inclusao_produto": "Inclusão de produto",
	"autorecprom_desconto_produto": "Desconto no produto",
	"autorecprom_discount_percentual": "Percentual",
	"autorecprom_num_renovacao_info": "Quando uma renovação cair em uma regra, defina o número de recorrências para as quais a promoção será aplicada.",
	"autorecprom_rule_product": "Produto",
	"autorecprom_rule_valor": "Valor",
	"autorecprom_save_success": "Regra de promoção atualizada com sucesso.",
	"voce_quer_ativar_esta_promocao": "Realmente deseja ativar esta promoção?",
	"voce_quer_inativar_esta_promocao": "Realmente deseja inativar esta promoção?",
	"autorecset_limit_warn_promo": "(0 é ilimitado).",

	"autorecprom_event_general_title": "Eventos Gerais",
	"autorecprom_event_rules_title": "Eventos de Regras",
	"autorecprom_event_discounts_title": "Eventos de Descontos",
	"autorecprom_event_line": "Linha",
	"autorecprom_event_field": "Campo",
	"autorecprom_event_old_value": "Valor anterior",
	"autorecprom_event_new_value": "Novo valor",

	"autorecnewprom_new": "Nova",
	"autorecnewprom_edit": "Editar",
	"autorecnewprom_promotion": "Promoção",
	"autorecnewprom_promotion_subscription": "Assinatura",
	"autorecnewprom_promotion_subscriptions": "Assinaturas",
	"autorecnewprom_promotion_rule": "regra de promoção",
	"autorecnewprom_promotion_rulename": "Nome da regra",
	"autorecnewprom_promotion_review": "Revise sua promoção",
	"autorecnewprom_promotion_rulemaxrec": "Limite de recorrências",
	"autorecnewprom_promotion_when_match": "Quando a assinatura for...",
	"autorecnewprom_promotion_unlimited": "(ilimitado)",
	"autorecnewprom_promotion_percentage": "Porcentagem",
	"autorecnewprom_promotion_status": "Status",
	"autorecnewprom_promotion_value": "Valor",
	"autorecnewprom_promotion_type": "Tipo",
	"autorecnewprom_promotion_activated": "Ativo",
	"autorecnewprom_promotion_activate": "Ativar",
	"autorecnewprom_promotion_activatef": "ativada",
	"autorecnewprom_promotion_desactivated": "Inativo",
	"autorecnewprom_promotion_desactivate": "Inativar",
	"autorecnewprom_promotion_desactivatef": "inativada",
	"autorecnewprom_promotion_amount": "Valor",
	"autorecnewprom_promotion_recnumber": "Número da recorrência",
	"autorecnewprom_promotion_province": "Estado",
	"autorecnewprom_promotion_aprovince": "Estado do endereço",
	"autorecnewprom_promotion_date": "Data",
	"autorecnewprom_billing_date": "Data de cobrança",
	"autorecnewprom_promotion_operator": "Operador",
	"autorecnewprom_promotion_operator_greater": "maior que",
	"autorecnewprom_promotion_operator_less": "menor que",
	"autorecnewprom_promotion_operator_contains": "contém",
	"autorecnewprom_promotion_operator_equals": "igual a",
	"autorecnewprom_promotion_operator_between": "entre",
	"autorecnewprom_promotion_product": "Produto",
	"autorecnewprom_promotion_and": "+",
	"autorecnewprom_promotion_then": "Então...",
	"autorecnewprom_promotion_action": "Ação",
	"autorecnewprom_promotion_save": "Salvar",
	"autorecnewprom_promotion_close": "Fechar",
	"autorecnewprom_promotion_greater_then": "Valor total",
	"autorecnewprom_promotion_greater_then_shipping": "Valor total (sem frete)",
	"autorecnewprom_promotion_product_amount": "Valor do produto",
	"autorecnewprom_promotion_contains_products": "Produtos",
	"autorecnewprom_promotion_renewal": "Número da recorrência",
	"autorecnewprom_promotion_date": "Data da assinatura",
	"autorecnewprom_promotion_date_and": "e",
	"autorecnewprom_promotion_initial_date": "Data inicial",
	"autorecnewprom_promotion_final_date": "Data final",
	"autorecnewprom_subscriptions_empty": "Nenhuma assinatura",
	"autorecnewprom_subscriptions_message_activate": "Você quer ativar essa promoção?",
	"autorecnewprom_subscriptions_message_desactivate": "Você quer desativar essa promoção?",
	"autorecnewprom_promotion_error_no_name": "Você não pode salvar a promoção com nome em branco.",
	"autorecnewprom_promotion_error_no_rules": "Você não pode salvar a promoção com regras em branco.",
	"autorecnewprom_promotion_error_no_discounts": "Você não pode salvar a promoção com descontos em branco.",

	"autorecautomation_id": "Código",
	"autorecautomation_empty": "Não há resultados",
	"autorecautomation_titulo": "Nome da regra",
	"autorecautomation_targets": "Alvos",
	"autorecautomation_target_type": "Tipo de alvo",
	"autorecautomation_acoes": "Ação",
	"autorecautomation_available": "Disponível",
	"autorecautomation_queued": "Na fila",
	"autorecautomation_running": "Em execução",
	"autorecautomation_title": "Automação",
	"autorecautomation_valor": "Valor total",
	"autorecautomation_valor_sem_frete": "Valor total (sem frete)",
	"autorecautomation_produto": "Produto",
	"autorecautomation_status": "Status",
	"autorecautomation_desconto_produto": "Desconto no produto",
	"autorecautomation_numero": "Número de recorrências",
	"autorecautomation_num_recorrencia": "Número da recorrência",
	"autorecautomation_estado": "Estado do assinante",
	"autorecautomation_data": "Data de criação",
	"autorecautomation_next_billing_date": "Data da próxima cobrança",
	"autorecautomation_billing_date": "Data da cobrança",
	"autorecautomation_product_amount": "Valor do produto",
	"autorecautomation_percentual": "Porcentagem",
	"autorecautomation_operator": "Operador",
	"autorecautomation_operator_greater": "maior que",
	"autorecautomation_operator_less": "menor que",
	"autorecautomation_operator_contains": "contém",
	"autorecautomation_operator_not_contains": "não contém",
	"autorecautomation_operator_equals": "igual a",
	"autorecautomation_operator_between": "entre",
	"autorecautomation_when_match": "Quando a assinatura for...",
	"autorecautomation_tipo": "Tipo",
	"autorecautomation_and": "+",
	"autorecautomation_initial_date": "Data inicial",
	"autorecautomation_final_date": "Data Final",
	"autorecautomation_save": "Salvar",
	"autorecautomation_then": "Então...",
	"autorecautomation_action": "Ação",
	"autorecautomation_remover_produto": "Remover produto",
	"autorecautomation_adicionar_produto": "Incluir de produto",
	"autorecautomation_substituir_produto": "Substituir produto",
	"autorecautomation_cancelar": "Cancelar",
	"autorecautomation_replaced": "A ser substituído",
	"autorecautomation_replace": "A substituir",
	"autorecautomation_by": "por",
	"autorecautomation_alterar_valor_produto": "Alterar valor produto",
	"autorecautomation_alterar_desconto_produto": "Alterar desconto no produto",
	"autorecautomation_alterar_desconto_frete": "Alterar desconto no frete",
	"autorecautomation_error_automation": "Você precisa definir um título para sua automação",
	"autorecautomation_error_no_filter": "Você não pode salvar a automação com filtros em branco.",
	"autorecautomation_error_no_actions": "Você não pode salvar a automação com ações em branco.",
	"autorecautomation_review": "Revise sua automação",
	"autorecautomation_close": "Fechar",
	"autorecautomation_execute": "Executar",
	"autorecautomation_incluir": "Nova regra de automação",
	"autorecautomation_alterar": "Editar regra de automação",

	"ph_xppnome": "Nome da empresa",
	"ph_storeurl": "URL da loja",
	"ph_email": "E-mail de contato",
	"ph_order_number": "Número da ordem",
	"ph_payment_method": "Método de pagamento",
	"ph_amount_brl": "Valor em BRL",
	"ph_boleto_code": "Código do boleto",
	"ph_submission_date": "Data de criação",
	"ph_product_name": "Nome do produto",
	"ph_products_list": "Lista de produtos (quantidade, nome e valor)",
	"ph_url_cobranca": "URL de cobrança (Link de Pagamento)",
	"ph_expiration_date": "Data de vencimento",
	"ph_auto_generated": "Ordem original",
	"ph_customer_taxid": "CPF/CNPJ do cliente",
	"ph_customer_name": "Nome do cliente",
	"ph_customer_email": "E-mail do cliente",
	"ph_customer_phone": "Telefone do cliente",
	"ph_customer_street": "Endereço do cliente",
	"ph_customer_zip": "CEP do cliente",
	"ph_customer_city": "Cidade do cliente",
	"ph_customer_state": "Estado do cliente",
	"ph_url_cancel": "URL para cancelamento",
	"ph_rule_type": "Tipo da regra",
	"ph_rule_product": "Produto da regra",
	"ph_rule_frequency": "Frequência da regra",
	"ph_billing_date": "Data da cobrança",
	"ph_cancellation_reason": "Motivo de cancelamento",

	"title_account_estab_comercial": "Estabelecimento",
	"ec_merchant_number": "Código do Estabelecimento",
	"ec_name": "Nome",
	"ec_cnpj": "CNPJ",
	"ec_status": "Status",
	"ec_response": "Retorno",
	"ec_confirmation_code": "Protocolo",
	"ec_pending": "Pendente",
	"ec_success": "Sucesso",
	"ec_update": "Atualizar",
	"ec_error": "Erro",
	"ec_tipo_usuario": "Tipo de Usuário",
	"ec_status": "Status",
	"ec_bloqueio_liquidacao": "Bloqueio Liquidação",
	"ec_protocolo": "Protocolo",
	"ec_telefone": "Telefone",
	"ec_celular": "Celular",
	"ec_tipo_conta": "Tipo Conta",
	"ec_banco": "Banco",
	"ec_agencia": "Agência",
	"ec_numero_conta": "Número Conta",
	"ec_erro": "Erro",
	"ec_status_cerc": "Status CERC",

	"title_unidade_recebivel": "Unidades de Recebíveis",
	"ur_id": "Id",
	"ur_reference": "Referência",
	"ur_merchant": "Merchant",
	"ur_status": "Status",
	"ur_type": "Tipo",
	"ur_scheme_code": "Cód. Arranjo",
	"ur_gross_amount": "Valor Bruto",
	"ur_net_amount": "Valor Líquido",
	"ur_processing_date": "Data de Processamento",
	"ur_confirmation_code": "Protocolo",
	"ur_ativo": "Ativo",
	"ur_to_be_update": "A Atualizar",
	"ur_updated": "Atualizado",
	"ur_create_unit": "Criar Unidade",
	"ur_update_unit": "Atualizar Unidade",
	"ur_deactivate": "Inativar",
	"ur_void": "Baixar",
	"ur_referencia_externa": "Referência Externa",
	"ur_cnpj_credenciadora": "CNPJ Credenciadora",
	"ur_cnpj_recebedor": "CNPJ Recebedor",
	"ur_date": "Data",
	"ur_status": "Status",
	"ur_tipo_operacao": "Tipo Operação",
	"ur_cod_arranjo": "Cod. Arranjo",
	"ur_valor_bruto": "Valor Bruto",
	"ur_valor_constituido": "Valor Constituído",
	"ur_valor_constituido_pre": "Valor Pré-Const.",
	"ur_valor_bloqueado": "Valor Bloqueado",
	"ur_valor_liquido": "Valor Líquido",
	"ur_valor_liquido_efetivo": "Valor Líq. Efetivo",
	"ur_data_liquidacao": "Data Liquidação",
	"ur_data_liq_efetiva": "Data Liq. Efetiva",
	"ur_data_processamento": "Data Processamento",
	"ur_protocolo": "Protocolo",

	"title_pos_contratada": "Pós-contratada",
	"pc_id": "Id",
	"pc_reference": "Referência",
	"pc_type": "Tipo",
	"pc_scheme_code": "Cód. Arranjo",
	"pc_anticipated_amount": "Valor Antecipado",
	"pc_processing_date": "Data de Processamento",
	"pc_confirmation_code": "Protocolo",
	"pc_create_contract": "Criar Contrato",
	"pc_update_contract": "Atualizar Contrato",
	"pc_deactivate": "Inativar",
	"pc_void": "Baixar",
	"pc_tipo_operacao": "Tipo de Operação",
	"pc_referencia_externa": "Referência Externa",
	"pc_cnpj_credenciadora": "CNPJ Credenciadora",
	"pc_cnpj_recebedor": "CNPJ Recebedor",
	"pc_codigo_arranjo": "Cód. Arranjo",
	"pc_data_liquidacao": "Data Liquidação",
	"pc_data_contrato_antecipacao": "Data Contrato Antec.",
	"pc_valor_antecipado": "Valor Antecipado",
	"pc_valor_constituido_antecipado": "Valor Constituído Antec.",
	"pc_identificador_operacao": "Identificar Operação",
	"pc_instituicao_credenciadora_arranjo": "Instituição Cred. Arranjo",
	"pc_cnpj_titular": "CNPJ Titular",
	"pc_tipo_conta": "Tipo de Conta",
	"pc_banco": "Banco",
	"pc_agencia": "Agência",
	"pc_numero_conta": "Número da Conta",
	"pc_valor_pago": "Valor Pago",
	"pc_data_pagamento": "Data Pagamento",
	"pc_protocolo": "Protocolo",

	"uo_title": "Administração de Ordem",
	"uo_msg_sucesso": "Sucesso",
	"uo_msg_warning": "Atenção",
	"uo_msg_warning_find_order": "Ordem nao encontrada",
	"uo_msg_insert_admorder": "Inserir",
	"uo_msg_update_admorder": "Alterar",

	"uo_aba_principal": "Informações Principais",
	"uo_aba_cliente": "Informações do Cliente",
	"uo_aba_boleto": "Informações do Boleto",
	"uo_aba_complementar": "Informações Adicionais",
	"uo_aba_pagamento": "Informações de Pagamento",
	"uo_aba_cartao": "Dados do Cartão",
	"uo_aba_cotacao": "Informações Cotação",
	"uo_aba_fee": "Informações FEE",
	"apply_order_rules": "Aplicar regras da ordem",

	//principais
	"uo_order_number": "Número do Pedido",
	"uo_internal_number": "Número Interno",
	"uo_payment_method": "Método de Pagamento",
	"uo_status": "Status",
	"uo_amount": "Valor",
	"uo_submission_date": "Data de Submissão",
	"uo_product": "Produto",
	"uo_param_url": "URL Parâmetro",
	"uo_due_date": "Data de Vencimento",

	//cliente
	"uo_customer_name": "Nome",
	"uo_customer_taxid": "CPF/CNPJ",
	"uo_customer_email": "E-mail",
	"uo_customer_phone": "Telefone",
	"uo_customer_address": "Endereço",
	"uo_customer_postalcode": "CEP",
	"uo_customer_state": "Estado",
	"uo_customer_city": "Cidade",

	//boleto
	"uo_boleto_code": "Código de Boleto",
	"uo_urlbol": "URL Boleto",

	//complementares
	"uo_shop_code": "Shop Code",
	"uo_nf": "NF",
	"uo_url_return": "URL Return",
	"uo_custom": "Custom",
	"uo_score": "Score",
	"uo_api": "API",
	"uo_gateway": "Gateway",
	"uo_erro": "Error",
	"uo_auto_generated": "Auto Generated",
	"uo_ordem_original": "Original Order",
	"uo_percentual": "Percentual",
	"uo_payment_option": "Payment Option",
	"uo_authentication": "Authentication",
	"uo_authentication_onfailure": "Authentication Onfailure",
	"uo_verificador": "Verificador",
	"uo_products_list": "Lista de produtos",

	//pagamento
	"uo_pay_date": "Data de Pagamento",
	"uo_amt_paid": "Valor Pago",
	"uo_amt_refnd": "Valor Refund",
	"uo_refd_date": "Data Refund",
	"uo_refd_info": "Informação Refund",
	"uo_rep_date": "Data Report",
	"uo_repref_dt": "Data Report Refund",
	"uo_confirmation_date": "Data Confirmação",

	//dados de cartão
	"uo_nsu": "NSU",
	"uo_tid": "TID",
	"uo_aut_code": "Authorization Code",
	"uo_cc_inst": "CC Inst",
	"uo_cc_brand": "CC Brand",
	"uo_cc_auth": "CC Auth",
	"uo_cc_holder": "CC Holder",
	"uo_cc_number": "CC Number",
	"uo_cc_token": "CC Token",
	"uo_cc_exp": "CC Exp",
	"uo_cc_bin": "CC Bin",

	//cotacao garantida
	"uo_fx_amount": "Valor Fx",
	"uo_fx_refunded": "Valor Refund Fx",
	"uo_fx_rate": "Taxa Fx",
	"uo_fx_rate_refund": "Taxa Refund Fx",
	"uo_fx_currency": "Moeda Fx",

	//fee
	"uo_fee": "Fee",
	"uo_fee_ref": "Fee Refund",
	"uo_feesp": "Fee SP",
	"uo_feeja": "Fee Advance Interest",
	"uo_fix": "Fix",
	"uo_feepb": "Fee PB",
	"uo_markup_fix": "Markup Fix",

	"title_efeito_contrato": "Efeito de Contrato",
	"efec_id": "Id",
	"efec_remittance_date": "Data de Liquidação",
	"efec_free_amount": "Valor Livre",
	"efec_confirmation_code": "Protocolo",
	"efec_documento_titular": "Documento Titular",
	"efec_data_liquidacao": "Data Liquidação",
	"efec_constituicao": "Constituição",
	"efec_valor_livre": "Valor Livre",
	"efec_protocolo": "Protocolo",
	"efec_indicador_efeitos_contrato": "Indicador efeitos contr.",
	"efec_cnpj_entidade_registradora": "CNPJ Entidade Reg.",
	"efec_tipo_efeito": "Tipo de Efeito",
	"efec_cnpj_beneficiario_titular": "CNPJ Benef. Titular",
	"efec_regra_divisao": "Regra Divisão",
	"efec_valor_comprometido": "Valor Comprometido",
	"efec_numero_documento_titular": "Número Doc. Titular",
	"efec_tipo_conta": "Tipo de Conta",
	"efec_ispb": "ISPB",
	"efec_agencia": "Agência",
	"efec_numero_conta": "Número de Conta",
	"efec_banco": "Banco",

	"gw_title": "Relatório Gateway",
	"gwrep_id": "Código",
	"gwrep_order_number": "Ordem",
	"gwrep_data_insercao": "Data de Inserção",
	"gwrep_epoch": "Epoch",
	"gwrep_report_date": "Data do Report",
	"gwrep_fee": "taxa",
	"gwrep_tipo": "Tipo",
	"gwrep_acao": "Ação",
	"gwrep_auth_request": "Requisição de autorização",
	"gwrep_auth_capture_request": "Requisição de autorização/captura",
	"gwrep_refund_request": "Requisição de reembolso",
	"gwrep_capture_request": "Requisição de captura",
	"gwrep_pb_debit_credit": "Débito/Crédito da PagBrasil",
	"gwrep_token_service_request": "Requisição de tokenização",
	"gwrep_token_service_use": "Uso de tokenização",
	"gwrep_undefined": "Indefinido",

	"ps_title": "Relatório PagShield",
	"ps_id": "Identificador",
	"ps_shd_order": "Ordem",
	"ps_shd_bol": "Código",
	"ps_shd_epoch": "Epoch",
	"ps_shd_date": "Data",
	"ps_rep_fee": "Data de relatório",
	"ps_screening": "Triagem",
	"ps_shd_score": "Pontuação",
	"ps_shd_act": "Ação",
	"ps_shd_fee": "Taxa",
	"ps_shd_fee_total": "Taxa Total",

	"remittance_report_title": "Relatório de remessa",
	"remittance_title": "Remessa",
	"remittance_merchant": "Estabelecimento",
	"remittance_base_date": "Data Base",
	"remittance_last_settlement": "Retornar último settlement gerado",
	"remittance_status": "Status",
	"remittance_quantidade": "Quantidade",
	"remittance_total": "Total",

	"remittance_data_arquivo": "Data",
	"remittance_valor_bruto": "Valor Bruto",
	"remittance_valor_fee": "Fees",
	"remittance_valor_refund": "Refunds",
	"remittance_valor_cb": "Chargebacks",
	"remittance_valor_cd_gateway": "Valor CD Gateway",
	"remittance_valor_liquido": "Valor Líquido",
	"remittance_valor_remessa": "Remessa",
	"remittance_valor_reserva": "Reserva",
	"remittance_valor_reserva_anterior": "Última Reserva",
	"remittance_valor_processado": "Processado",

	"remittance_data_pagamento_fw": "Data Pagamento",
	"remittance_favorecido_fw": "Favorecido",
	"remittance_valor_fee_fw": "Valor Fee",
	"remittance_valor_repasse_fw": "Valor Repasse",

	"remittance_valor_total": "Valor Total",
	"remittance_valor_pago_total": "Valor Pago Total",
	"remittance_valor_reembolso_total": "Reembolso Total",
	"remittance_fee_total": "Fee Total",
	"remittance_fee_reembolso_total": "Fee Reembolso Total",
	"remittance_dado_adicionado_report": "Dado que será adicionado no pbreport",
	"remittance_arquivo": "Arquivo",
	"remittance_currency": "Moeda",
	"remittance_valor_liquido": "Valor líquido",
	"remittance_valor_bruto": "Valor total",
	"remittance_total_chargeback": "Chargeback total",
	"remittance_total_processed": "Processed total",
	"remittance_total_reserve": "Reserva total",
	"remittance_valor_remessa": "Valor de remessa",
	"remittance_fx_rate": "FX Rate",
	"remittance_atualizar_fee": "Atualizar Fee",
	"remittance_linha_report": "Linha Report",
	"remittance_gerar_csv": "Gerar CSV",
	"remittance_vincular_ordens": "Vincular Ordens",
	"remittance_comparar": "Comparar",
	"remittance_acao": "Ação",
	"remittance_ajuste": "Ajuste",
	"remittance_undo": "Desfaz remessa",
	"remittance_tooltip_process": "Realiza o processo completo para todos os merchants listados",
	"remittance_tooltip_linha_report": "Insere a linha no pbreport.dbf e insere o registro no mysql",
	"remittance_tooltip_gerar_csv": "Gera o arquivo CSV, e cadastra a snapshot no mysql",
	"remittance_tooltip_vincular_ordens": "Marca as ordens como pertencentes a este report. rep_date e repref_dt",
	"remittance_tooltip_comparar": "Compara com o sistema antigo",
	"remittance_tooltip_atualizar_fee": "Atualiza as fees dos registros de gateway que não são internos",
	"remittance_tooltip_undo": "Desfaz a remessa",
	"remittance_summary": "Resumo do processamento",

	"fee_remittance_title": "Taxa mínima de manutenção",
	"fee_remittance_tipo": "Tipo",

	"title_remittance_anticipation": "Antecipação de remessa",
	"remittance_anticipation_list": "Listagem",
	"remittance_anticipation_status": "Status",
	"remittance_anticipation_data_insercao": "Data de inserção",
	"remittance_anticipation_data_antecipacao": "Data inicial de antecipação",
	"remittance_anticipation_data_deposito": "Data de depósito",
	"remittance_anticipation_data_para_relatorio": "Data para relatório",
	"remittance_anticipation_valor_solicitado": "Valor requisitado",
	"remittance_anticipation_valor_bruto": "Valor bruto",
	"remittance_anticipation_valor_final": "Valor final",
	"remittance_anticipation_acoes": "Ações",
	"remittance_anticipation_status_waiting": "Aguardando",
	"remittance_anticipation_status_approved": "Aprovado",
	"remittance_anticipation_status_rejected": "Rejeitado",

	"remittance_anticipation_field_order_number": "Order number",
	"remittance_anticipation_field_status": "Status",
	"remittance_anticipation_field_efeito_contrato": "Efeito de contrato",
	"remittance_anticipation_field_amt_paid": "Valor pago",
	"remittance_anticipation_field_amt_refnd": "Valor reemb.",
	"remittance_anticipation_field_order_fee": "Fee",
	"remittance_anticipation_field_order_fee_ref": "Fee refund",
	"remittance_anticipation_field_order_data_repasse": "Data de repasse",
	"remittance_anticipation_field_order_amt_anticipation": "Valor antecipação",

	"remittance_anticipation_button_preview_anticipation": "Pré-visualizar",
	"remittance_anticipation_total_anticipation": "Valor total da antecipação: ",
	"remittance_anticipation_button_request_anticipation": "Solicitar antecipação",
	"remittance_anticipation_type": "Tipo",
	"remittance_anticipation_taxa_adiantamento": "Taxa de antecipação mensal",
	"remittance_anticipation_taxa_adicional": "Taxa adicional",
	"remittance_anticipation_feeremit": "Taxa de remessa",

	"title_repasse_agendado": "Agenda de Liberação de Repasses",
	"repasseagendado_calendar": "Calendário",
	"repasseagendado_movements": "Transações",
	"repasseagendado_id": "Id",
	"repasseagendado_arquivo": "Relatório",
	"repasseagendado_order_number": "Ordem",
	"repasseagendado_status": "Status",
	"repasseagendado_valor": "Valor (R$)",
	"repasseagendado_data_insercao": "Data de Pagamento",
	"repasseagendado_data_liberacao": "Data de Liberação",
	"repasseagendado_data_previsao": "Data de Previsão",
	"repasseagendado_payment_method": "Forma de Pagamento",
	"repasseagendado_mes_filtro": "Mês",
	"repasseagendado_liberado": "Liberação",
	"repasseagendado_previsto": "Previsão",
	"repasseagendado_resultado_futuro": "Resultados futuros",

	"catalogo_title": "Catálogo de produtos",
	"catalogo_categoria_title": "Categorias",
	"catalogo_categoria_name": "Nome",
	"catalogo_categoria_erro": "Essa categoria não pode ser excluída.",

	"catalogo_produto_title": "Produtos",
	"catalogo_produto_sku": "SKU",
	"catalogo_produto_name": "Nome",
	"catalogo_produto_description": "Descrição",
	"catalogo_produto_image_link": "Link imagem",
	"catalogo_produto_amount": "Valor",
	"catalogo_produto_categoria_id": "Categoria",
	"catalogo_produto_erro": "Esse produto não pode ser excluído.",

	"proforma_conta_fechada": "Incluir contas fechadas",
	"proforma_maior_min_remittance": "Maior que min. remittance",
	"proforma_aglutinar": "Aglutinar",
	"proforma_agrupamento": "Agrupamento",
	"proforma_pre_geracao": "Pré Geração",
	"proforma_finalizacao": "Finalização",
	"proforma_separar": "Separar",
	"proforma_merchant": "Merchant",
	"proforma_currency": "Currency",
	"proforma_min_remittance": "Min. Remittance",
	"proforma_pending_amount": "Pending Amount (BRL)",
	"proforma_pending_remittance": "Pending Remittance",
	"proforma_status": "Status",
	"proforma_fazer": "Fazer",
	"proforma_valor_calculado": "Valor Calculado",
	"proforma_data_base": "Data base",
	"proforma_empty_base_date": "Data base vazia",
	"proforma_consolidate_title": "Consolidação",
	"proforma_empty_consolidated_list": "Selecione pelo menos um merchant para consolidar.",
	"proforma_empty_exchange_rate": "Por favor, preencha a cotação de moeda.",
	"proforma_empty_exchange_rate_currency": "Por favor, preencha a cotação de moeda para a moeda {currency}.",

	"invoice_gerar": "Gerar invoice",
	"invoice_pre_gerar": "Pré gerar invoice",
	"invoice_merchant": "Merchant",
	"invoice_currency": "Moeda",
	"invoice_valor_remessa": "Valor remessa",
	"invoice_valor_processado": "Valor processado",
	"invoice_data_arquivo": "Data do relatório",
	"invoice_fazer": "Ação",
	"payment_invoice_title": "Invoice Payment",
	"invoice_fee_value": "Valor da Taxa",
	"invoice_confirm_title": "Confirmar Geração de Invoice",
	"invoice_confirm_message": "Deseja realmente gerar as invoices para os merchants selecionados?",
	"invoice_confirm_count": "Quantidade de merchants selecionados",
	"invoice_date_required": "Por favor, informe a data da invoice.",
	"invoice_no_selection": "Por favor, selecione pelo menos um merchant para gerar a invoice.",
	"invoice_success": "Invoices geradas com sucesso!",

	"processment_title": "Processamento",
	"processment_merchant": "Merchant",
	"processment_currency": "Moeda",
	"processment_data_arquivo": "Data",
	"processment_last_valor_remessa": "Último valor de remessa",
	"processment_last_valor_reserva": "Última reserva",
	"processment_next_valor_reserva": "Próxima reserva",
	"processment_valor_remessa": "Valor de remessa",
	"processment_valor_processado": "Valor processado",
	"processment_fazer": "Ação",
	"processment_pre_repasse_gerado": "Pré-repasse",
	"processment_invoice": "Invoice",

	"operacao_cancelada": "Operação cancelada.",
	"operacao_concluida": "Operação concluída.",
	"voce_tem_certeza": "Você tem certeza?",
	"voce_tem_certeza_excluir": "Você tem certeza que deseja excluir a conta ",
	"processo_irreversivel": "Este processo é irreversível.",
	"remove_conteudo": "Você tem certeza que deseja limpar TODOS os pedidos e manter as informações de configuração da conta ",
	"voce_quer_excluir": "Você quer excluir este registro?",
	"voce_quer_atualizar": "Você quer atualizar este registro?",
	"exclusao_sucesso": "Exclusão realizada com sucesso.",
	"inclusao_sucesso": "Inclusão realizada com sucesso.",
	"alteracao_sucesso": "Alteração realizada com sucesso.",
	"erro_indefinido": "Erro indefinido.",
	"warning_opening_link": "Atenção: Este é um link externo que não foi validado pela PagBrasil e pode conter conteúdo malicioso.",

	"search_merchant": "Buscar Estabelecimentos",
	"filter_nota_gerada": "Nota Gerada",
	"search": "Buscar",
	"filter": "Filtro",
	"tipo": "Tipo",
	"periodo": "Período",
	"select_periodo": "Selecione o período.",
	"select_date": "Selecionar Data.",
	"total": "Total",
	"Quant": "Qtd.",
	"test_upper": "TESTE",
	"closed_upper": "FECHADA",
	"amount_brl": "Valor (R$)",
	"pec_code": "Código do PEC",
	"pix_image": "QR Code do Pix (URL da imagem)",
	"pix_qrcode": "QR Code do Pix (Imagem)",
	"source_code": "Código Fonte",
	"submit_all": "Submeter Todos",
	"actions": "Ações",
	"show_more": "Mostrar mais",

	"add_payment_option": "Adicionar todos",
	"remove_payment_option": "Remover todos",

	"choose": "* selecione",
	"sorry_no_match": "Desculpe, nenhum resultado encontrado.",

	"calendario": "Calendário",
	"listagem": "Lista",
	"incluir": "Incluir",
	"alterar": "Atualizar",
	"confirm": "Confirmar",
	"eventos": "Eventos",
	"true": "Verdadeiro",
	"false": "Falso",
	"show": "Exibir",
	"hide": "Ocultar",
	"action": "Ação",
	"date_format": "Formato de Data",
	"yes": "Sim",
	"no": "Não",
	"Ativo": "Ativo",
	"Inativo": "Inativo",
	"created_at": "Criado em",
	"updated_at": "Atualizado em",
	"ON": "Ligado",
	"OFF": "Desligado",
	"Success": "Sucesso",
	"All": "Todos",
	"recycle": "Reciclar",
	"of": "de",
	"today": "Hoje",
	"range_to": "até",
	"limit": "Limite",
	"old": "Antigo",
	"new": "Novo",
	"new_ignore_i": "Transaction Rev.",
	"subtracao": "Subtração",
	"adicao": "Adição",
	"consolidate": "Consolidar",
	"paid_via": "Pago por",
	"dark": "Escuro",
	"light": "Claro",
	"copied_to_clipboard": "Copiado para a área de transferência",

	"direct": "Direto",
	"api": "API",
	"calculo": "Cálculo",

	"semicolon": "Ponto e vírgula",
	"pipe": "Pipe",
	"colon": "Dois pontos",
	"slash": "Barra",
	"exclamation_mark": "Exclamação",
	"hyphen": "hífen",

	"fixed": "Fixa",
	"variable": "Variável",
	"placeholder": "Placeholder",
	"placeholders": "Placeholders",
	"process": "Processar",

	"merchant": "Estabelecimento",
	"razao_social": "Razão Social",
	"default_upper": "PADRÃO",
	"no_results_found": "Nenhum resultado encontrado",
	"copy": "Copiar",
	"code": "Código",
	"newPaymentLink": "Novo Payment Link",
	"using_balance": "Utilizando saldo",
	"using_balance_of_cd": "Utilizando saldo do CD",
	"balance": "Saldo",
	"empty": "Vazio",

	"mfa_enable_two_factor": "Ative a autenticação em dois fatores (obrigatório)",
	"mfa_step1": "Faça o download e instalação de um aplicativo de autenticação em seu telefone. Nós recomendamos o  Microsoft Authenticator, Google Authenticator ou Duo.",
	"mfa_step2": "No aplicativo, escaneie o QR code abaixo.",
	"mfa_enter_verification": "Informe o código",

	"ipn_title": "Histórico de IPNs",
	"results_per_page": "Resultados por página",
	"search_for_ipn": "Buscar por IPN",
	"search_ipn": "Buscar IPN",
	"ipn_date": "Data",
	"ipn_session_id": "IPN ID",
	"ipn_status": "Status",
	"ipn_action": "Ação",
	"ipn_refresh": "Atualizar",
	"ipn_list_unsuccessful": "Listar todos os IPNs malsucedidos",
	"ipn_view_resend": "Ver/Reenviar IPN",
	"ipn_success": "Sucesso",
	"ipn_fail": "Falha",
	"ipn_not_compliant": "Incompatível",
	"ipn_resend_ipn": "Reenviar IPN",
	"ipn_content": "Conteúdo",
	"ipn_click_here_to_see": "Clique aqui para ver",
	"ipn_operation_successfully": "Processado com sucesso!",
	"ipn_url_envio": "IPN URL",

	"payment_title": "Histórico",
	"ui_label_payment": 'Pagamento',
	"payment_id_hash": "Payment ID",
	"payment_type": "Tipo",
	"payment_status": "Status",
	"payment_date": "Data",
	"payment_pix_data": "Dados Pix",
	"payment_extra_info": "Descrição interna",
	"payment_amount": "Valor",
	"payment_amount_brl": "Valor (R$)",
	"payment_fx_amount": "Valor",
	"payment_fx_fix": "Taxa",
	"payment_action": "Ações",
	"payment_type_payment": "Pagamento",
	"payment_type_balance": "Transferência",
	"payment_transfer_type": "Tipo de transferência",
	"payment_transfer_deposit": "Depósito",
	"payment_transfer_withdraw": "Saque",
	"payment_type_fee": "Tarifa",
	"payment_status_open": "Requisitado",
	"payment_status_authorized": "Iniciado",
	"payment_status_completed": "Confirmado",
	"payment_status_refunded": "Reembolsado",
	"payment_status_error": "Erro",
	"payment_status_error_initiate": "Erro iniciação",
	"payment_status_initiated": "Iniciado",
	"payment_status_confirmed": "Confirmado",
	"payment_status_processing": "Processando",
	"payment_pix_key": "Chave pix",
	"payment_pix_key_type": "Tipo da chave Pix",
	"payment_qr_code": "QR Code",
	"payment_pix_descriptor": "Descrição",
	"payment_type_phone": "Telefone",
	"payment_type_taxid": "CPF/CNPJ",
	"payment_type_email": "E-mail",
	"payment_type_alternative": "Alternativo",
	"payment_required_fields": "Por favor, preencha todos os campos obrigatórios.",
	"payment_customer_name": "Nome",
	"payment_customer_email": "E-mail",
	"payment_customer_address": "Endereço",
	"payment_customer_id": "ID",
	"payment_customer": "Cliente",
	"payment_payment_description": "Descrição do pagamento",
	"payment_initiate": "Initiate",
	"payment_confirm": "Confirm",
	"payment_beneficiario": "Beneficiário",
	"payment_credit_info": "Informações de crédito",
	"payment_authorization_code": "Código de autorização",
	"payment_bank": "Banco",
	"payment_branch": "Agência",
	"payment_account": "Conta",
	"payment_name": "Nome",
	"payment_pix_taxid": "CPF/CNPJ",
	"payment_taxid": "Tax ID:",
	"payment_pix_pix_person_type": "Tipo de pessoa",
	"payment_pix_pix_person_type_business": "Jurídica",
	"payment_pix_pix_person_type_individual": "Física",
	"payment_transaction_history": "Histórico",
	"payment_cancel": "Cancelar",

	"payment_initiation_fee": "Taxa de iniciação",
	"payment_confirmation_fee": "Taxa de confirmação",
	"payment_refund_fee": "Taxa de reembolso",
	"payment_fee": "Taxa",
	"payment_fee_brl": "Taxa (R$)",
	"payment_fix": "Fixo",
	"payment_fix_brl": "Fixo (R$)",
	"payment_authorization_code": "Código de autorização",

	"payment_setting_title": "Configurações do Pagamento",
	"payment_settings_active": "Ativo",
	"payment_settings_legacy_api": "Usar API legado",
	"payment_settings_balance_fx": "Saldo FX",
	"payment_settings_minimum_balance": "Saldo mínimo FX",
	"payment_settings_webhook_refund": "URL do webhook de reembolsos",
	"payment_settings_webhook": "URL do webhook",
	"payment_settings_currency": "Moeda de saldo",
	"payment_settings_remittance_currency": "Moeda de remessa",

	"payment_settings_config_title": "Payment setting config",
	"payment_settings_config_entry_currency": "Moeda de entrada",
	"payment_settings_config_connector": "Conector",
	"payment_settings_config_acoes": "Ação",

	"payment_remittance_title": "Repasse de pagamentos",
	"payment_report_title": "Relatórios de Pagamentos",
	"payment_report_preview": "Visualizar",
	"payment_report_filters": "Filtros",
	"payment_report_filters_clear": "Limpar",
	"payment_report_filters_date": "Data",
	"payment_report_select_option": "Selecione uma opção de relatório",
	"payment_report_transactions_report": "Relatório de Transações",
	"payment_report_start_date": "Data inicial",
	"payment_report_end_date": "Data final",
	"payment_report_report_preview": "Pré-visualização do relatório",
	"payment_report_export_total": "Total a ser exportado",
	"payment_report_rows": "registro(s)",
	"payment_report_empty_rows": "Não há registros neste relatório",
	"payment_report_generate": "Gerar CSV",
	"payment_report_created_at": "Data de submissão",
	"payment_report_id": "ID do pagamento",
	"payment_report_status": "Status",
	"payment_report_customer_id": "ID do cliente final",
	"payment_report_customer_name": "Nome do cliente final",
	"payment_report_customer_email": "E-mail do cliente final",
	"payment_report_customer_address": "Endereço do cliente final",
	"payment_report_amount_brl_due": "Valor devido a ser pago em BRL",
	"payment_report_fx_amount_due": "Valor devido a ser pago em {exchange}",
	"payment_report_amount_brl_paid": "Valor pago em BRL",
	"payment_report_fx_amount_paid": "Valor pago em {exchange}",
	"payment_report_amount_brl_refunded": "Valor reembolsado em BRL",
	"payment_report_fx_amount_refunded": "Valor reembolsado em {exchange}",
	"payment_report_fee_brl": "Taxa em BRL",
	"payment_report_fee_fx": "Taxa em {exchange}",
	"payment_report_fx_rate_id": "ID da taxa de câmbio",
	"payment_report_fx_rate": "Taxa de câmbio",
	"payment_report_authorization_code": "Código de autorização",
	"payment_report_pix_name": "Nome do destinatário",
	"payment_report_pix_taxid": "CPF/CNPJ do destinatário",
	"payment_report_pix_person_type": "Tipo de entidade do destinatário",
	"payment_report_pix_key": "Chave Pix do destinatário",
	"payment_report_pix_key_type": "Tipo de chave Pix do destinatário",
	"payment_report_pix_code": "Código Pix do destinatário",
	"payment_report_pix_descriptor": "Descrição do Pix do destinatário",
	"payment_report_pix_bank": "Número do banco do destinatário",
	"payment_report_pix_branch": "Número da agência do destinatário",
	"payment_report_pix_account": "Número da conta do destinatário",
	"payment_report_payment_description": "Descrição interna",
	"payment_report_fx_balance": "Saldo em moeda {exchange}",
	"payment_invoice_number": "Número da invoice",

	"resource_integration_manual": "Manual de Integração - Métodos de Pagamento, PagStream®, Link de Pagamento, Payouts e Reconciliação",
	"resource_cpfcnpj_validation": "Rotinas de validação de CPF/CNPJ",
	"resource_payment_method_image": "Imagens e logos dos métodos de pagamento",
	"resource_guide_boleto_flash": "Guia do Lojista: Boleto Flash® - Set 2021",
	"resource_guide_pix": "Guia do Lojista: Pix - Set 2021",
	"resource_guide_pec_flash": "Guia do Lojista: PEC Flash® - Set 2021",
	"resource_guide_pagshield": "Guia do Lojista: Prevenção de Fraude PagShield - Set 2021",
	"resource_guide_recurring": "Guia do Lojista: Pagamentos Recorrentes  - Set 2021",
	"resource_guide_proof_of_delivery": "Guia do Lojista: Comprovante de Envio - Set 2021",
	"resource_guide_customer_support": "Guia do Lojista: Suporte ao Cliente - Set 2021",
	"resource_guide_pre_authorized_orders": "Guia do Lojista: Revisão Manual de Pedidos Pré-Autorizados - Set 2024",

	"menu_area_assinante_configuracao": "Configuração",
	"area_assinante_subdomain_already_taken": "Subdomínio já registrado",
	"area_assinante_subdomain_invalid_char": "Subdomínio contém caracteres inválidos",
	"area_assinante_subdomain": "Subdomínio",
	"area_assinante_cor_base": "Cor base da página de login",
	"area_assinante_sombra_login": "Cor da sombra na página de login",
	"area_assinante_icone_profile": "Ícone do perfil",
	"area_assinante_cor_barra_superior": "Cor da barra superior",
	"area_assinante_html_botao_cancelamento": "Substituir botão de cancelamento",
	"area_assinante_logo_pagstream": "Logo na página de login",
	"area_assinante_logo_pagstream_barra": "Logo na barra superior",
	"area_assinante_seleção_arquivo": "Nenhum arquivo selecionado",
	"area_assinante_pause": "Pausar assinatura",
	"area_assinante_activate": "Ativar assinatura",
	"area_assinante_skip": "Pular próxima recorrência",
	"area_assinante_pause_text": "Texto exibido quando o cliente escolhe pausar",
	"area_assinante_skip_text": "Texto exibido quando o cliente escolhe pular",
	"area_assinante_pausar_assinatura_template": "Você pode pausar a sua assinatura por um período de tempo que seja mais conveniente para você. Pode ser por algumas semanas ou até meses, dependendo das suas necessidades.",
	"area_assinante_pular_assinatura_template": "Você pode pular a próxima cobrança e retornar sua assinatura na próxima fatura. Não cobraremos nenhuma taxa adicional. Queremos que você tenha total liberdade para gerenciar a sua relação conosco.",

	"consolidatedtaxid_order": "Ordem",
	"consolidatedtaxid_amount_paid": "Valor pago",
	"consolidatedtaxid_net_amount": "Valor líq.",
	"consolidatedtaxid_amount_refunded": "Valor reembolsado",
	"consolidatedtaxid_taxid": "CPF/CNPJ",
	"consolidatedtaxid_name": "Nome",
	"consolidatedtaxid_taxid_adjusted": "CPF/CNPJ ajustado",
	"consolidatedtaxid_name_adjusted": "Nome Ajustado",

	"in": "contêm",
	"weekly": "Semanalmente",
	"monthly": "Mensalmente",
	"quarterly": "Trimestralmente",
	"semiannually": "Semestralmente",
	"yearly": "Anualmente",

	"day": "Dia",
	"week": "Semana",
	"month": "Mês",
	"quarter": "Trimestre",
	"year": "Ano",

	"days": "Dias",
	"weeks": "Semanas",
	"months": "Meses",
	"quarters": "Trimestres",
	"years": "Anos",

	"unlimited": "Ilimitado",

	"month_jan": "Janeiro",
	"month_feb": "Fevereiro",
	"month_mar": "Março",
	"month_apr": "Abril",
	"month_may": "Maio",
	"month_jun": "Junho",
	"month_jul": "Julho",
	"month_aug": "Agosto",
	"month_sep": "Setembro",
	"month_oct": "Outubro",
	"month_nov": "Novembro",
	"month_dec": "Dezembro",

	"errormsg_UrlTransf": "Por padrão, nós apenas permitimos conexões para URLs HTTPS na porta 443. Se você utilizar uma porta diferente em uma URL de IPN, por favor entre em contato conosco solicitando uma exceção.",
	"errormsg_Periodo31Dias": "Por favor, selecione menos de 31 dias.",
	"errormsg_31days": "Data inválida. O intervalo máximo de datas é de 31 dias.",
	"errormsg_please_filter": "Por favor, selecione o filtro para visualizar o relatório.",
	"errormsg_request": "Ocorreu um erro indefinido.",
	"errormsg_request_file": "Ocorreu um erro ao gerar o arquivo.",
	"errormsg_value_greater_than": "'{0}' deve ser maior que '{1}'.",
	"errormsg_value_not_zero": "'{0}' deve ser maior que 0.",
	"warningmsg_perm": "Você não pode alterar os merchants.",

	"errormsg_InicioMenorTermino": "A data final deve ser maior que a data inicial.",
	"errormsg_minvencpix": "O valor mínimo deste campo é 1 minuto.",
	"errormsg_maxvencpix": "O valor máximo deste campo é 7200 minutos.",
	"title_vencpix": "Defina o número de minutos para o pix expirar (1 a 7200). Isso se aplica a todos os seus Pix (NÃO incluindo aqueles já emitidos).",

	"texto_bol_desc": "O campo permite a tag de nova linha &#60;br&#62;",

	"modal_insert_account_gateway_credential": "Nova Credencial de Gateway",
	"modal_update_account_gateway_credential": "Atualizar Credencial de Gateway",
	"account_gateway": "Gateway",
	"account_gateway_order": "Ordem",
	"account_key": "Chave",
	"account_terminal_id": "Terminal ID",
	"account_partner_id": "Parceiro ID",
	"account_seller_id": "Vendedor ID",
	"account_homologation": "Homologação",
	"label_user_token_enabled": "Token :",
	"message_token_user_enabled": "Token habilitado. Ação valida somente ao clicar no botão de enviar .",
	"message_token_user_disabled": "Token desabilitado. Ação valida somente ao clicar no botão de enviar.",
	"super_account_group_description": "Descrição",
	"super_account_group_prefix_for_card_table": "Prefixo para tabela de cartão",
	"title_error_validation": "Erro de validação",
	"super_account_group_empty_fields_error":"Preencha ambos os campos!",
	"super_account_revenue_group_description": "Descrição",
	"placeholder_revenue_search": "Digite o nome ou número do grupo",
	"super_account_group_empty_field_desc":"Preencha o campo de descrição!",

	"group": {
		"request_error_generic": "Não foi possível processar a solicitação. Tente novamente",
		"duplicate_card_table_prefix": "Já existe um grupo com este prefixo de tabela de cartão",
		"duplicate_name": "Já existe um grupo com este nome",
		"duplicate_name_and_prefix": "Já existem grupos com este nome e com este prefixo de tabela de cartão",
		"duplicate_record": "Não foi possível salvar o grupo: registro duplicado"
	},

	"super_process_fee_title": "Configuração de Taxas",
	"super_process_fee_grupo" : "Grupo de Faturamento",
	"super_process_fee_ativo" : "Ativo",
	"super_process_fee_faturamento" : "Faturamento Mensal (BRL)",
	"super_process_fee_pix" : "Taxa Pix",
	"super_process_fee_boleto_flash" : "Taxa Boleto Flash",
	"super_process_fee_pec" : "Taxa PEC Flash",
	"super_process_fee_boleto_bancario" : "Taxa Boleto Bancário",
	"super_process_fee_banking" : "Taxa Online Banking",
	"super_process_fee_paypal" : "Taxa Paypal",
	"super_process_fee_pagbrasil" : "Taxa Solução PagBrasil Intermediação",
	"super_process_fee_pagbrasil_gateway" : "Taxa Solução PagBrasil Gateway",
	"super_process_fee_debito" : "Taxa Cartão de Débito",
	"super_process_fee_cc_oneoff" : "Taxa Cartão de Crédito (à vista)",
	"super_process_fee_cc_2_to_6" : "Taxa Cartão de Crédito (Parcelado 2 até 6)",
	"super_process_fee_cc_7_to_12" : "Taxa Cartão de Crédito (Parcelo 7 até 12)",
	"super_process_fee_data" : "Última data de revisão",
	"super_process_fee_user" : "Modificado por último por",
	"super_process_fee_error_campos" : "Preencha corretamente os campos",
	"super_process_fee_error_delete" : "Não é possivel deletar um campo ativo",
	"super_process_fee_error_update" : "Não é possivel desativar um campo ativo",

	"message_attention_remittance_schedule": "Atenção - Há agendamentos configurados mas o sistema de remessa agendada não está ativado.",
	"message_schedule_remittance_settlement_report": "Repasse agendado",

	"amount_refunded_total_amount": "Valor total",

	"label_wallet": "Carteira",
	"google_pay": "Google Pay",
	"samsung_pay": "Samsung Pay",
	"apple_pay": "Apple Pay",

	"ui_label_mid": "Histórico POS",
	"mid_option_no": "Não",
	"mid_option_yes": "Sim",
	"mid_option_yes_with_filter": "Sim, Com filtro por MID",

	"clone_of": "Clone de",

	"ui_label_block_card_gateway": "Bloqueio de cartão",
	"block_card_yes": "Sim",
	"block_card_no": "Não",

	"ui_label_fix_additional_channel_dash": "Fixo adicional channel Remoto",
	"ui_label_fee_additional_channel_dash": "Taxa adicional channel Remoto",
	"ui_label_fix_additional_channel_pos": "Fixo adicional channel POS",
	"ui_label_fee_additional_channel_pos": "Taxa adicional channel POS",

	"date_format_language": "dd/MM/yyyy",

	"ss_scheduled": "Agendado",
	"ss_finished": "Processado",
	"ss_unprocessed": "Não processado",

	"tooltip_report": "Relatório",
	"tooltip_invoice": "Fatura",

	"so_download": "Fazer download",
	"so_filter": "Filtrar",
	"so_clear": "Limpar",

	"client": "Cliente",
	"conta_corrente": "Conta Corrente",
	"conta_salario": "Salário",
	"conta_poupanca": "Poupança",
	"conta_transferencia": "Transferência",

	"overview_overview": "Visão Geral",
	"overview_period": "Período",
	"overview_payment_method": "Método de pagamento",
	"overview_invoicing": "Faturamento",
	"overview_conversion": "Conversão",
	"overview_latest_completed_orders": "Últimos pedidos completados",
	"overview_last_notices": "Últimos avisos",
	"overview_view_all_notices": "Visualizar todos os avisos",
	"overview_date": "Data",
	"overview_order": "Pedido",
	"overview_orders": "Pedidos",
	"overview_method": "Método",
	"overview_type": "Tipo",
	"overview_notice": "Aviso",
	"overview_total": "Total",
	"overview_completed": "Completados",
	"overview_filter_by": "Filtrar por",
	"overview_filter": "Filtrar",
	"overview_filter_start_date": "Data inicial",
	"overview_filter_end_date": "Data final",
	"overview_filter_all": "Todos",
	"overview_chart_no_data": "Nenhum dado disponível",
	"overview_validate_date_error": "O intervalo selecionado não pode ser maior que 31 dias.",
	"overview_currency_brl": "R$ ",

	"trial_search_title": "Buscar Trial",
	"trial_status_title": "Status",
	"trial_search_code": "Código do Trial",
	"trial_search_status_completed": "Completado",
	"trial_search_status_expired": "Expirado",
	"trial_search_status_open": "Aberto",
	"trial_search_status_canceled": "Cancelado",
	"trial_search_expiration_date": "Data de expiração",
	"trial_search_cancel_date": "Data de cancelamento",

	"pagstream_overview_percentage_tooltip": "Em comparação com:",
	"pagstream_overview_next_30_days_revenue_tooltip": "Receita total prevista para os próximos 30 dias",
	"pagstream_overview_lifetime_value_tooltip": "Média de receita que um cliente gera ao longo do vínculo dele com o lojista",
	"pagstream_overview_active_subscriptions_tooltip": "Quantidade total de assinaturas ativas",

	"pagstream_overview_period": "Período:",
	"pagstream_overview_compare_with": "Comparar com:",
	"pagstream_overview_total_revenue": "Total de receita",
	"pagstream_overview_next_30_days_revenue": "Receita para os próximos 30 dias",
	"pagstream_overview_lifetime_value": "LTV (Lifetime Value)",
	"pagstream_overview_average_ticket": "Ticket médio por assinatura",
	"pagstream_overview_active_subscriptions": "Assinaturas ativas",
	"pagstream_overview_new_subscriptions": "Novas assinaturas",
	"pagstream_overview_retries_revenue": "Receita recuperada com retentativas",
	"pagstream_overview_pl_revenue": "Receita recuperada com link de pagamento",
	"pagstream_overview_retrieved_orders": "Ordens recuperadas",
	"pagstream_overview_retrieved_orders_flag": "(Total Payment Link e retentativas)",
	"pagstream_overview_billing_errors": "Erros de cobrança",
	"pagstream_overview_charge_revenue": "Receita de churn",
	"pagstream_overview_churn_rate": "Taxa de churn",
	"pagstream_overview_purchase_items": "Itens mais comprados",
	"pagstream_overview_errors_by_type": "Erros por tipo",
	"pagstream_overview_cancellation_reasons": "Motivos de cancelamento",

	"cost_config_date": "Data Vigência",
	"cost_config_bank": "Banco",
	"cost_config_adquirente": "Adquirente",
	"cost_config_mcc": "MCC",
	"cost_config_brand": "Bandeira",
	"cost_config_installments": "Parcelas",
	"cost_config_installments_2a6": "Parcelas 2 à 6",
	"cost_config_installments_7a12": "Parcelas 7 à 12",

	"posregister_id": "Id",
	"posregister_pos_id": "POS Id",
	"posregister_email": "E-mail",
	"posregister_active": "Ativo",
	
	"nupay_type_translate_credit": "Crédito",
	"nupay_type_translate_debit": "Débito",

	"required_fields_error": "Por favor preencha todos os campos obrigatórios!",
	"tax_id_invalid": "Por favor verifique o CPF/CNPJ informado!",
	
	"modelocontrato_title": "Modelos de contrato",
	"modelocontrato_form_description": "Descrição",

	"nome_contrato_coluna": "Nome do arquivo do contrato",
	"modelo_contrato_coluna": "Modelo de contrato",
	"modelo_contrato_placeholder": "Selecionar um modelo",
	"data_inicial_revisao_coluna": "Data inicial da revisão",
	"troca_faixa_ativa": "A faixa desse grupo precisa ser revisada.",
	"troca_faixa_inativa": "Aguardando data inicial para revisão.",

	"revenue_group_history_title": "Histórico de modificação",
	"label_pix_automatico_fee": "Pix Automático Fee",
	"label_pix_automatico_fix": "Pix Automático Fix",
	"label_approved_consent_fix": "Consentimento aprovado Fix",
	"label_ui_pix_automatico": "Pix Automático",
	"label_ui_pix_automatico_retry_auto": "Retentativa de Pix automático",
	"pix_automatico_retry_auto_on_demand": "Sob demanda",
	"pix_automatico_retry_auto_automatic": "Automático",

	"translate_pix_cycle_weekly": "Semanal",
	"translate_pix_cycle_monthly": "Mensal",
	"translate_pix_cycle_quarterly": "Trimestral",
	"translate_pix_cycle_semiannual": "Semestral",
	"translate_pix_cycle_annually": "Anual",
	"label_ui_pix_automatico_consents": "Consentimentos Pix Automático",
	"btn_pix_automatico_consents": "Consultar Autorizações",
	"modal_pix_consents_title": "Histórico de Consentimentos",

	"pix_auto_label_id": "Pix Rec. Id",
	"pix_auto_label_name": "Nome do pagador",
	"pix_auto_label_taxid": "CPF/CNPJ do pagador",
	"pix_auto_label_first_rec": "Data da primeira cobrança",
	"pix_auto_label_status": "Status",
	"pix_auto_label_status_autorizado": "Autorizado",
	"pix_auto_label_status_cancelado": "Cancelado",
	"pix_auto_label_status_pendente": "Não iniciado",
	"pix_auto_label_status_desautorizado": "Desautorizado",
	"pix_auto_label_empty": "Nenhum consentimento encontrado.",

	"pix_auto_label_retry": "Retentativa",
	"pix_auto_label_retry_not_allowed": "Não permitida",
	"pix_auto_label_retry_allowed": "Ativada",
	
	"pix_auto_label_taxid_placeholder": "Pesquise pelo CPF ou CNPJ",
	"pix_auto_label_name_placeholder": "Pesquise pelo nome do pagador",
	"pix_auto_label_id_placeholder": "Pesquise pelo ID da recorrência",
}

export default pt
